// import React, { useEffect, useState } from "react";
// import { connect } from 'react-redux'
// import { AutoComplete, Input, DatePicker, TimePicker, message } from 'antd'
// import moment from "moment";
// import { fetchClassList, fetchSubList, fetchTeacherList, postCreateSchedule, setClass, setEndTime, setMode, setSartDate, setEndDate, setStartTime, setSubject, setTeacher, setWeekDays, setScheduleIdDelete, fetchTimetableData, fetchSchedule, setDelOrCancel, setCurrentDate, fetchScheduleFilter, setSubscriptionModal } from 'actions/schedule'
// import SavingModal from 'components/SavingModal'

// import calenderIcon from "../../Assets/schedule/calendar.svg";
// import deleteIcon from "../../Assets/schedule/delete.svg";
// import clockIcon from "../../Assets/schedule/clock.svg";
// import downArrowIcon from "../../Assets/schedule/downArrow.svg";
// import upArrowIcon from "../../Assets/schedule/upArrow.svg";

// const ScheduleEditTab = ({
//   schedule,
//   // redux state + actions
//   subList, subId, classList, teacherList, weekdays, classId, teacherId, startTime, endTime, startDate, endDate, mode,
//   fetchSubList, fetchClassList, fetchTeacherList, setSubject, setClass, setTeacher, setStartTime, setEndTime, setSartDate, setEndDate, setMode, setWeekDays,
//   postCreateSchedule, fetchSchedule, fetchTimetableData, fetchScheduleFilter, setScheduleIdDelete, setDelOrCancel, setSubscriptionModal, subsAlertData, tabType, stdTimetable, currentDate, teacherSearch, classFilter, subFilter,
//   setCurrentDate, onCancel = () => {}, onSave = () => {}
// }) => {
//   const data = schedule?.schedule || schedule;
//   if (!data) return null;

//   const [colorDays, setColorDays] = useState([false, false, false, false, false, false, false])
//   const [optionSub, setOptionsSub] = useState([])
//   const [optionClass, setOptionsClass] = useState([])
//   const [optionTeacher, setOptionsTeacher] = useState([])
//   const [cachedSubList, setCachedSubList] = useState(null)
//   const [cachedClassList, setCachedClassList] = useState(null)
//   const [cachedTeacherList, setCachedTeacherList] = useState(null)
//   const [subName, setSubName] = useState('')
//   const [className, setClassName] = useState('')
//   const [teacherName, setTeacherName] = useState('')
//   const [classNameArr, setClassNameArr] = useState([])
//   const [buttonColor, setButtonColor] = useState([false, false, false, false, false])
//   const [subjectLoader, setSubjectLoader] = useState(false)
//   const [stdLoader, setStdLoader] = useState(false)
//   const [teacherLoader, setTeacherLoader] = useState(false)
//   const [saveLoader, setSaveLoader] = useState(false)
//   const [showSavingModal, setShowSavingModal] = useState(false)
//   const [scheduleId, setScheduleId] = useState(null)
//   const [accessEdit, setAccessEdit] = useState(false)
//   const [showBatchInput, setShowBatchInput] = useState(false)
//   const [subjectDropdownOpen, setSubjectDropdownOpen] = useState(false)
//   const [batchDropdownOpen, setBatchDropdownOpen] = useState(false)
//   const [showAddBatchBtn, setShowAddBatchBtn] = useState(false)
//   const [initialFormState, setInitialFormState] = useState(null)
//   const [hoverStartDate, setHoverStartDate] = useState(false)
//   const [hoverEndDate, setHoverEndDate] = useState(false)
//   const [hoverStartTime, setHoverStartTime] = useState(false)
//   const [hoverEndTime, setHoverEndTime] = useState(false)

//   const format = 'hh:mm A'
//   const formatDate = "DD/MM/YYYY"

//   const pickerStyle = {
//     width: '100%',
//     height: 44,
//     border: 'none',
//     background: 'transparent',
//     padding: 0,
//     boxShadow: 'none',
//     outline: 'none',
//   };

//   // useEffect(() => {
//   //   // prefill from schedule
//   //   setSubName(data?.subject?.name || '')
//   //   setSubject(data?.subject?.id)
//   //   const cls = (data?.standards || []).map(i => ({ id: i.id, name: `${i.std}-${i.section}`}))
//   //   setClass(classId?.length ? classId : cls.map(c => c.id))
//   //   setClassNameArr(cls)
//   //   setClassName('')
//   //   setTeacherName(data?.teacher?.name || '')
//   //   setTeacher(data?.teacher?.id)
//   //   // store times in HH:mm for pickers
//   //   const st = data?.startTime ? moment(data.startTime, 'HH:mm:ss').format('HH:mm') : ''
//   //   const et = data?.endTime ? moment(data.endTime, 'HH:mm:ss').format('HH:mm') : ''
//   //   setStartTime(st)
//   //   setEndTime(et)
//   //   setSartDate(data?.startDate)
//   //   setEndDate(data?.endDate)
//   //   setMode(data?.mode)
//   //   setScheduleId(data?.scheduleId || data?.id)

//   //   // weekdays
//   //   const wd = data?.weekdays || []
//   //   setWeekDays(wd)
//   //   const newColor = [false, false, false, false, false, false, false]
//   //   wd.forEach(d => {
//   //     if (d === 'sunday') newColor[0] = true
//   //     if (d === 'monday') newColor[1] = true
//   //     if (d === 'tuesday') newColor[2] = true
//   //     if (d === 'wednesday') newColor[3] = true
//   //     if (d === 'thursday') newColor[4] = true
//   //     if (d === 'friday') newColor[5] = true
//   //     if (d === 'saturday') newColor[6] = true
//   //   })
//   //   setColorDays(newColor)

//   //   // access edit if current
//   //   const todayDate = moment().format('YYYY-MM-DD')
//   //   const currentTime = moment().format('HH:mm')
//   //   if (todayDate === data?.startDate) {
//   //     if (currentTime >= moment(data?.startTime, 'HH:mm:ss').format('HH:mm') && currentTime <= moment(data?.endTime, 'HH:mm:ss').format('HH:mm')) {
//   //       setAccessEdit(true)
//   //     }
//   //   }
//   // }, [data])

//   useEffect(() => {
//     // prefill from schedule
//     const subjectName = data?.subject?.name || ''
//     const subjectId = data?.subject?.id
//     const cls = (data?.standards || []).map(i => ({ id: i.id, name: `${i.std} : ${i.section}`}))
//     const clsIds = classId?.length ? classId : cls.map(c => c.id)
//     const teacherNameValue = data?.teacher?.name || ''
//     const teacherIdValue = data?.teacher?.id
//     const st = data?.startTime ? moment(data.startTime, 'HH:mm:ss').format('HH:mm') : ''
//     const et = data?.endTime ? moment(data.endTime, 'HH:mm:ss').format('HH:mm') : ''
//     const wd = data?.weekdays || []
//     const newColor = [false, false, false, false, false, false, false]
//     wd.forEach(d => {
//       if (d === 'sunday') newColor[0] = true
//       if (d === 'monday') newColor[1] = true
//       if (d === 'tuesday') newColor[2] = true
//       if (d === 'wednesday') newColor[3] = true
//       if (d === 'thursday') newColor[4] = true
//       if (d === 'friday') newColor[5] = true
//       if (d === 'saturday') newColor[6] = true
//     })

//     // Set all form values
//     setSubName(subjectName)
//     setSubject(subjectId)
//     setClass(clsIds)
//     setClassNameArr(cls)
//     setClassName('')
//     setTeacherName(teacherNameValue)
//     setTeacher(teacherIdValue)
//     setStartTime(st)
//     setEndTime(et)
//     setSartDate(data?.startDate)
//     setEndDate(data?.endDate)
//     setMode(data?.mode)
//     setScheduleId(data?.scheduleId || data?.id)
//     setWeekDays(wd)
//     setColorDays(newColor)

//     // 🔥 CAPTURE INITIAL STATE - this is what reset will restore to
//     setInitialFormState({
//       subName: subjectName,
//       subId: subjectId,
//       classId: clsIds,
//       classNameArr: cls,
//       teacherName: teacherNameValue,
//       teacherId: teacherIdValue,
//       startTime: st,
//       endTime: et,
//       startDate: data?.startDate,
//       endDate: data?.endDate,
//       mode: data?.mode,
//       weekdays: wd,
//       colorDays: newColor
//     })

//     // access edit check...
//     const todayDate = moment().format('YYYY-MM-DD')
//     const currentTime = moment().format('HH:mm')
//     if (todayDate === data?.startDate) {
//       if (currentTime >= moment(data?.startTime, 'HH:mm:ss').format('HH:mm') && currentTime <= moment(data?.endTime, 'HH:mm:ss').format('HH:mm')) {
//         setAccessEdit(true)
//       }
//     }
//   }, [data])

//   useEffect(() => {
//     const opts = subList ? subList.map((item, index) => ({ key: index, value: item.name, label: item.name, id: item.id })) : []
//     if ((!opts || opts.length === 0)) {
//       setOptionsSub([{ key: 'no-data', value: 'no-data', label: 'No subject found', disabled: true }])
//     } else {
//       setOptionsSub(opts)
//     }
//     if (!subName) setCachedSubList(subList)
//   }, [subList, subName])

//   useEffect(() => {
//     const selectedIds = Array.isArray(classId) ? classId : []
//     const available = classList ? classList.filter(c => !selectedIds.includes(c.id)) : []
//     const opts = available.map((item, index) => ({ key: index, value: `${item.std}-${item.section}`, label: `${item.std}-${item.section}`, id: item.id }))
//     if ((!opts || opts.length === 0)) {
//       setOptionsClass([{ key: 'no-data', value: 'no-data', label: 'No batch found', disabled: true }])
//     } else {
//       setOptionsClass(opts)
//     }
//     if (!className) setCachedClassList(classList)
//   }, [classList, className])

//   useEffect(() => {
//     const opts = teacherList ? teacherList.map((item, index) => ({ key: index, value: item.name, label: item.name, id: item.id })) : []
//     if ((!opts || opts.length === 0) && teacherName) {
//       setOptionsTeacher([{ key: 'no-data', value: 'no-data', label: 'No instructor found', disabled: true }])
//     } else {
//       setOptionsTeacher(opts)
//     }
//     if (!teacherName) setCachedTeacherList(teacherList)
//   }, [teacherList, teacherName])

//   useEffect(() => {
//     // fetch initial lists
//     fetchSubList()
//     fetchTeacherList('')
//   }, [])

//   const handleSearchTeacher = (value) => {
//     if (!value) setTeacherName('')
//     else { setTeacherName(value); setTeacherLoader(true) }
//     fetchTeacherList(value, () => setTeacherLoader(false))
//   }

//   const handleSearchSub = (value) => {
//     if (!value) setSubName('')
//     else { setSubName(value); setSubjectLoader(true) }
//     fetchSubList(value, () => setSubjectLoader(false))
//   }

//   const onSelectSub = (value, option) => {
//     if (!value || value === 'no-data') return
//     const id = option?.id || (subList && subList.find(s => s.name === value)?.id)
//     if (id) {
//       setSubject(id)
//       setSubName(value)
//       setClass([])
//       setClassNameArr([])
//       fetchClassList('', id)
//     } else {
//       setSubject(null)
//       setSubName('')
//     }
//   }

//   const handleSearchClass = (value) => {
//     if (value) { setClassName(value); setStdLoader(true); fetchClassList(value, subId, () => setStdLoader(false)) }
//     else { setClassName(''); fetchClassList('', subId, () => setStdLoader(false)) }
//   }

//   const onSelectClass = (value, option) => {
//     if (!value || value === 'no-data') return
//     const id = option?.id || (classList && classList.find(c => `${c.std}-${c.section}` === value)?.id)
//     if (id) {
//       const newClassIds = Array.isArray(classId) ? [...classId] : []
//       const newClassNameArr = Array.isArray(classNameArr) ? [...classNameArr] : []
//       if (!newClassIds.includes(id)) {
//         newClassIds.push(id)
//         newClassNameArr.push({ id: id, name: value })
//         setClass(newClassIds)
//         setClassNameArr(newClassNameArr)
//       }
//       setClassName('')
//       // hide the batch input only when there are no more remaining batches to select
//       const remaining = (classList || []).filter(c => !newClassIds.includes(c.id))
//       if ((remaining || []).length === 0) {
//         setShowBatchInput(false)
//         setBatchDropdownOpen(false)
//       }
//       fetchTeacherList('')
//     } else {
//       setClass([]); setClassName(''); setClassNameArr([]); setTeacher(null); setTeacherName('')
//     }
//   }

//   const onSelectTeacher = (value, option) => {
//     if (!value || value === 'no-data') return
//     const id = option?.id || (teacherList && teacherList.find(t => t.name === value)?.id)
//     if (id) { 
//       setTeacher(id)
//       setTeacherName(value)
//     } else { setTeacher(null); setTeacherName('') }
//   }

//   const handleDaysButtonColor = (value, active) => {
//     let newWeekdays = Array.isArray(weekdays) ? [...weekdays] : []
//     const newColor = [...colorDays]
//     const toggleDay = (index, dayName) => {
//       newColor[index] = !active
//       if (newColor[index]) { if (!newWeekdays.includes(dayName)) newWeekdays.push(dayName) }
//       else { newWeekdays = newWeekdays.filter((w) => w !== dayName) }
//       setColorDays(newColor)
//     }
//     if (value == "Su") toggleDay(0, 'sunday')
//     else if (value == "M") toggleDay(1, 'monday')
//     else if (value == "T") toggleDay(2, 'tuesday')
//     else if (value == "W") toggleDay(3, 'wednesday')
//     else if (value == "Th") toggleDay(4, 'thursday')
//     else if (value == "F") toggleDay(5, 'friday')
//     else if (value == "S") toggleDay(6, 'saturday')
//     setWeekDays(newWeekdays)
//   }

//   const onChangeStartDate = (date, dateString) => {
//     if (dateString) { setSartDate(moment(dateString, 'DD/MM/YYYY').format('YYYY-MM-DD')) }
//     else setSartDate('')
//     setEndDate('')
//   }

//   const onChangeLastDate = (date, dateString) => {
//     if (dateString) setEndDate(moment(dateString, 'DD/MM/YYYY').format('YYYY-MM-DD'))
//     else setEndDate('')
//   }

//   const onChangeStartTime = (time, timestring) => {
//     setEndTime('')
//     if (time) {
//       const timestring24 = moment(time, format).format('HH:mm')
//       if (mode === 'Zoom 40') {
//         const end = moment(timestring24, 'HH:mm').add(40, 'minutes')
//         setEndTime(end.format('HH:mm'))
//       }
//       setStartTime(timestring24)
//     } else setStartTime('')
//   }

//   const onChangeEndTime = (time, timestring) => {
//     if (time) setEndTime(moment(time, format).format('HH:mm'))
//     else setEndTime('')
//   }

//   const isFormValidEdit = Boolean(scheduleId && subId && startTime && endTime && startDate && endDate && mode && Array.isArray(classId) && classId.length !== 0 && teacherId && Array.isArray(weekdays) && weekdays.length !== 0)

//   const onClose = (value) => {
//     const newClassNameArr = classNameArr.filter((item) => item.id != value)
//     const newClassIds = (Array.isArray(classId) ? classId : []).filter((item) => item != value)
//     setClass(newClassIds)
//     setClassNameArr(newClassNameArr)
//     setClassName('')
//   }

//   const disabledStartDate = (current) => {
//     if (!current) return false
//     return current.isBefore(moment().startOf('day'))
//   }

//   const disabledDate = (current) => {
//     if (!current) return false
//     const beforeToday = current.isBefore(moment().startOf('day'))
//     if (startDate) {
//       const beforeStart = current.isBefore(moment(startDate, 'YYYY-MM-DD').startOf('day'))
//       return beforeToday || beforeStart
//     }
//     return beforeToday
//   }


//   const disabledStartTimeHours = () => {
//     const hours = []
//     if (moment().format('YYYY-MM-DD') === startDate) {
//       for (let i = 0; i < moment().hour(); i++) hours.push(i)
//     }
//     return hours
//   }

//   const disabledStartTimeMinutes = (selectedHour) => {
//     const minutes = []
//     if (selectedHour === moment().hour() && moment().format('YYYY-MM-DD') === startDate) {
//       for (let i = 0; i <= (moment().minute() + 1); i++) minutes.push(i)
//     }
//     return minutes
//   }

//   const disabledEndTimeHours = () => {
//     const hours = []
//     if (startTime) {
//       const startHour = moment(startTime, 'HH:mm').hour()
//       for (let i = 0; i < startHour; i++) hours.push(i)
//     }
//     return hours
//   }

//   const disabledEndTimeMinutes = (selectedHour) => {
//     const minutes = []
//     if (selectedHour === moment().hour() && moment().format('YYYY-MM-DD') === startDate) {
//       for (let i = 0; i < (moment(startTime, 'HH:mm').minutes() + 1); i++) minutes.push(i)
//     } else if (startTime && selectedHour === moment(startTime, 'HH:mm').hour()) {
//       for (let i = 0; i < (moment(startTime, 'HH:mm').minutes() + 1); i++) minutes.push(i)
//     }
//     return minutes
//   }

//   const createSchedule = () => {
//     // validate dates at save-time: do not allow past-start or end before start
//     const today = moment().startOf('day')
//     if (startDate && moment(startDate, 'YYYY-MM-DD').isBefore(today)) { message.error('Start date cannot be in the past'); return }
//     if (endDate && moment(endDate, 'YYYY-MM-DD').isBefore(today)) { message.error('End date cannot be in the past'); return }
//     if (startDate && endDate && moment(endDate, 'YYYY-MM-DD').isBefore(moment(startDate, 'YYYY-MM-DD'))) { message.error('End date cannot be before start date'); return }

//     if (scheduleId && subId && startTime && endTime && startDate && endDate && mode && (classId && classId.length != 0) && teacherId && weekdays && weekdays.length != 0) {
//       if ((mode !== 'Offline' && mode !== 'Others') && ((subsAlertData?.totalUserHours == 0) || (subsAlertData?.userHoursUsed >= subsAlertData?.totalUserHours))){
//         setSubscriptionModal(true);
//         return;
//       }

//       // ensure times are HH:mm:ss
//       const normalize = (t) => t && t.includes(':') && t.split(':').length === 3 ? t : (t ? `${t}:00` : t)

//       var objectSchedule = {
//         scheduleId: scheduleId,
//         teacherId: teacherId,
//         subjectId: subId,
//         classIds: classId,
//         weekdays: weekdays,
//         startTime: normalize(startTime),
//         endTime: normalize(endTime),
//         mode: mode,
//         startDate: startDate,
//         endDate: endDate
//       }

//       setSaveLoader(true)
//       postCreateSchedule(objectSchedule, () => setSaveLoader(false), successCallback)
//     } else {
//       message.error('please fill the all information')
//     }
//   }

//   const successCallback = () => {
//     // After saving, close the drawer and show the schedule list for the date we edited (startDate)
//     try {
//       // close the edit drawer
//       try { onCancel() } catch (er) {}

//       const todayYmd = moment().format('YYYY-MM-DD')
//       const targetYmd = startDate || todayYmd
//       const displayDate = targetYmd ? moment(targetYmd, 'YYYY-MM-DD').format('DD/MM/YYYY') : moment().format('DD/MM/YYYY')
//       setCurrentDate(displayDate)
//       // prefer fetchScheduleFilter (date-filtered) so view always shows the selected date's data
//       if (fetchScheduleFilter) {
//         fetchScheduleFilter(targetYmd, teacherSearch, classFilter, subFilter)
//       } else if (fetchSchedule) {
//         fetchSchedule(() => {}, targetYmd)
//       }
//       // notify parent
//       try { onSave({ date: targetYmd }) } catch (er) {}
//     } catch (e) {
//       if (fetchSchedule) fetchSchedule()
//     }
//     setSaveLoader(false)
//     setSubject(null)
//     setSubName('')
//     setTeacher(null)
//     setSartDate('')
//     setEndDate('')
//     setStartTime('')
//     setEndTime('')
//     setMode('')
//     setWeekDays([])
//     setClass([])
//     setClassNameArr([])
//   }

//   // determine if reset should be enabled (true when form has changes)
//   const isResetDisabled = (() => {
//     if (!initialFormState) return true
//     try {
//       const sameSub = initialFormState.subId === subId
//       const sameTeacher = initialFormState.teacherId === teacherId
//       const sameStart = initialFormState.startTime === startTime
//       const sameEnd = initialFormState.endTime === endTime
//       const sameStartDate = initialFormState.startDate === startDate
//       const sameEndDate = initialFormState.endDate === endDate
//       const sameMode = initialFormState.mode === mode
//       const sameClass = JSON.stringify(initialFormState.classId || []) === JSON.stringify(classId || [])
//       const sameWeek = JSON.stringify(initialFormState.weekdays || []) === JSON.stringify(weekdays || [])
//       return (sameSub && sameTeacher && sameStart && sameEnd && sameStartDate && sameEndDate && sameMode && sameClass && sameWeek)
//     } catch (e) { return true }
//   })()

//   return (
//     <div style={{ 
//       padding: '32px 24px',
//       fontFamily: 'Roboto, sans-serif',
//       maxWidth: '600px',
//       margin: '0 auto'
//     }}>
//       {/* Alert for ongoing class */}
//       {accessEdit && (
//         <div style={{ 
//           background: '#FFE5E5', 
//           borderRadius: 8, 
//           padding: '12px 16px', 
//           color: '#D32F2F', 
//           marginBottom: 24,
//           fontSize: 18,
//           lineHeight: '20px'
//         }}>
//           On-going class is not editable. Please try again once the class is over.
//         </div>
//       )}

//       {/* Subject Field */}
//       {/* <div style={{ marginBottom: 24 }}>
//         <div style={{ 
//             fontSize: 16, 
//             color: '#6B6B6B', 
//             marginBottom: 8,
//             fontWeight: 500
//           }}>
//             Subject <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
//           </div>
//         <div style={{ paddingBottom: 8 }}>
//           <AutoComplete
//             popupClassName="schedule-edit-dropdown"
//             options={optionSub}
//             onSearch={handleSearchSub}
//             onFocus={() => fetchSubList('')}
//             onDropdownVisibleChange={(open) => { if (open) { const list = cachedSubList || subList || []; setOptionsSub(list ? list.map((item, index) => ({ key: index, value: item.name, label: item.name, id: item.id })) : []); fetchSubList('') } }}
//             onSelect={onSelectSub}
//             onChange={(value) => {
//               if (!value) {
//                 setSubName('')
//                 setSubject(null)
//                 // clear batch selections and hide batch input until subject is added
//                 setClass([])
//                 setClassNameArr([])
//                 setShowBatchInput(false)
//                       setSubjectDropdownOpen(false)
//                 setShowAddBatchBtn(false)
//               }
//             }}
//             value={subName}
//             allowClear={true}
//             placeholder="Search subject"
//             style={{ width: '100%' }}
//             filterOption={false}
//           >
//             <Input 
//               bordered={false} 
//               style={{ 
//                 padding: 0,
//                 fontSize: 18,
//                 color: '#191919',
//                 fontWeight: 500
//               }} 
//             />
//           </AutoComplete>
//         </div>
//         <div style={{ width: '512px', height: '0px', borderTop: '1px solid #E6E6E6', opacity: 1 }} />
//       </div> */}

//       <div style={{ marginBottom: 24 }}>
//   <div
//     style={{
//       fontSize: 16,
//       color: '#6B6B6B',
//       marginBottom: 8,
//       fontWeight: 500,
//     }}
//   >
//     Subject <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
//   </div>

//   <div style={{ paddingBottom: 8 }}>
//     <AutoComplete
//       popupClassName="schedule-edit-dropdown"
//       options={optionSub}
//       open={subjectDropdownOpen} // ✅ controlled
//       onSearch={handleSearchSub}
//       onFocus={() => {
//         fetchSubList('');
//         setSubjectDropdownOpen(true); // open on focus
//       }}
//       onDropdownVisibleChange={(open) => {
//         setSubjectDropdownOpen(open);

//         if (open) {
//           const list = cachedSubList || subList || [];
//           setOptionsSub(
//             list.map((item, index) => ({
//               key: index,
//               value: item.name,
//               label: item.name,
//               id: item.id,
//             }))
//           );
//           fetchSubList('');
//         }
//       }}
//       onSelect={(value, option) => {
//         onSelectSub(value, option);
//         setSubjectDropdownOpen(false); // optional: close after select
//       }}
//       onChange={(value) => {
//         if (!value) {
//           setSubName('');
//           setSubject(null);

//           // clear dependent data
//           setClass([]);
//           setClassNameArr([]);
//           setShowBatchInput(false);
//           setShowAddBatchBtn(false);

//           // 🔥 reopen dropdown AFTER clear + blur
//           requestAnimationFrame(() => {
//             setSubjectDropdownOpen(true);
//           });
//         }
//       }}
//       value={subName}
//       allowClear
//       placeholder="Search subject"
//       style={{ width: '100%' }}
//       filterOption={false}
//     >
//       <Input
//         bordered={false}
//         style={{
//           padding: 0,
//           fontSize: 18,
//           color: '#191919',
//           fontWeight: 500,
//         }}
//       />
//     </AutoComplete>
//   </div>

//   <div
//     style={{
//       width: '512px',
//       height: '0px',
//       borderTop: '1px solid #E6E6E6',
//       opacity: 1,
//     }}
//   />
// </div>


//       {/* Batch Field */}
//       <div style={{ marginBottom: 24 }}>
//         <div style={{ 
//           fontSize: 16, 
//           color: '#6B6B6B',
//           fontWeight: 500,
//           marginBottom: 6
//         }}>
//           Batch <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
//         </div>
//         <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 6 }}>
//           {(classNameArr || []).map((c) => (
//             <div 
//               key={c.id} 
//               style={{ 
//                 display: 'flex', 
//                 justifyContent: 'space-between', 
//                 alignItems: 'center',
//                 padding: '4px 0',
//                 // borderBottom: '1px solid #E6E6E6',
//                 paddingBottom: 8
//               }}
//             >
//               <span style={{ 
//                 fontSize: 18, 
//                 color: '#191919',
//                 fontWeight: 500
//               }}>
//                 {c.name}
//               </span>
//               <img 
//                 src={deleteIcon} 
//                 onClick={() => onClose(c.id)} 
//                 alt="delete" 
//                 style={{ 
//                   width: 20, 
//                   height: 20, 
//                   cursor: 'pointer',
//                   opacity: 0.7
//                 }} 
//               />
//             </div>
//           ))}
//           {showBatchInput && (
//             <div style={{ position: 'relative', paddingBottom: 4 }}>
//               <AutoComplete
//                 popupClassName="schedule-edit-dropdown"
//                 options={optionClass}
//                 onSearch={handleSearchClass}
//                 onSelect={(value, option) => {
//                   onSelectClass(value, option);
//                   // close dropdown and hide the batch input after selecting a batch
//                   setBatchDropdownOpen(false)
//                   setShowBatchInput(false)
//                 }}
//                 onChange={(value) => {
//                   if (!value) {
//                     setClassName('')
//                   }
//                 }}
//                 onFocus={() => {
//                   setBatchDropdownOpen(true)
//                   fetchClassList('', subId)
//                 }}
//                   onDropdownVisibleChange={(open) => {
//                     if (open) {
//                       const list = cachedClassList || classList || [];
//                       const selectedIds = Array.isArray(classId) ? classId : [];
//                       const available = list ? list.filter(c => !selectedIds.includes(c.id)) : [];
//                       if ((available || []).length === 0) {
//                         setOptionsClass([{ key: 'no-data', value: 'no-data', label: 'No batch found', disabled: true }]);
//                       } else {
//                         setOptionsClass(available.map((item, index) => ({ key: index, value: `${item.std} : ${item.section}`, label: `${item.std} : ${item.section}`, id: item.id })));
//                       }
//                     }
//                     setBatchDropdownOpen(open);
//                     fetchClassList('', subId);
//                   }}
//                 onBlur={() => {
//                   setTimeout(() => {
//                     setBatchDropdownOpen(false)
//                   }, 200)
//                 }}
//                 value={className}
//                 placeholder="Search batch"
//                 style={{ width: '100%' }}
//                   open={batchDropdownOpen}
//                   disabled={!subId}
//                 filterOption={false}
//               >
//                 <Input 
//                   bordered={false} 
//                   style={{ 
//                     padding: 0,
//                     fontSize: 18,
//                     color: '#191919',
//                     fontWeight: 500,
//                     paddingRight: 30,
//                     cursor: subId ? 'text' : 'default'
//                   }}
//                   suffix={
//                     <img 
//                       src={batchDropdownOpen ? upArrowIcon : downArrowIcon} 
//                       alt={batchDropdownOpen ? "up arrow" : "down arrow"} 
//                       style={{ 
//                         width: 16, 
//                         height: 16,
//                         cursor: 'pointer'
//                       }}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         if (batchDropdownOpen) {
//                           setBatchDropdownOpen(false)
//                         } else {
//                           setBatchDropdownOpen(true)
//                           fetchClassList('', subId)
//                         }
//                       }}
//                     />
//                   }
//                 />
//               </AutoComplete>
//             </div>
//           )}
//         </div>
//         {subId ? (
//           <>
//             <div

//               onClick={() => {
//                 setShowAddBatchBtn(true)
//               }}
//             >
//               <div style={{ width: '100%', height: 0, borderTop: '1px solid #E6E6E6', opacity: 1 }} />
//             </div>
//             {showAddBatchBtn && ((cachedClassList || classList || []).filter(c => !((Array.isArray(classId) ? classId : []).includes(c.id))).length > 0) && (
//               <div 
//                 onClick={() => {
//                   if (subId) {
//                     setShowBatchInput(true);
//                     setBatchDropdownOpen(true);
//                     fetchClassList('', subId)
//                   }
//                 }}
//                 style={{ 
//                   color: subId ? '#1089FF' : '#A0A0A0', 
//                   fontWeight: 600,
//                   fontSize: 18,
//                   cursor: subId ? 'pointer' : 'default',
//                   letterSpacing: '0.5px',
//                   textAlign: 'right',
//                   userSelect: 'none'
//                 }}
//                 role="button"
//                 aria-disabled={!subId}
//               >
//                 ADD BATCH
//               </div>
//             )}
//           </>
//         ) : (
//           <div style={{ height: 12 }} />
//         )}
//       </div>

//       {/* Instructor Field */}
//       <div style={{ marginBottom: 24 }}>
//         <div style={{ 
//           fontSize: 16, 
//           color: '#6B6B6B', 
//           marginBottom: 8,
//           fontWeight: 500
//         }}>
//           Instructor <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
//         </div>
//         <div style={{ paddingBottom: 8 }}>
//           <AutoComplete
//             popupClassName="schedule-edit-dropdown"
//             options={optionTeacher}
//             onSearch={handleSearchTeacher}
//             onFocus={() => fetchTeacherList('')}
//             onDropdownVisibleChange={(open) => { if (open) { const list = cachedTeacherList || teacherList || []; setOptionsTeacher(list ? list.map((item, index) => ({ key: index, value: item.name, label: item.name, id: item.id })) : []); fetchTeacherList('') } }}
//             onSelect={onSelectTeacher}
//             onChange={(value) => {
//               if (!value) {
//                 setTeacherName('')
//                 setTeacher(null)
//               }
//             }}
//             value={teacherName}
//             allowClear={true}
//             placeholder="Search instructor"
//             style={{ width: '100%' }}
//             filterOption={false}
//           >
//             <Input 
//               bordered={false} 
//               style={{ 
//                 padding: 0,
//                 fontSize: 18,
//                 color: '#191919',
//                 fontWeight: 500
//               }} 
//             />
//           </AutoComplete>
//         </div>
//         <div style={{ width: '512px', height: '0px', borderTop: '1px solid #E6E6E6', opacity: 1 }} />
//       </div>
//       <style>
// {`
//   /* =========================
//      DROPDOWN (keep as-is)
//   ========================== */
//   .schedule-edit-dropdown .ant-select-item-option-selected {
//     background-color: #C6C2FF !important;
//     color: #191919 !important;
//     font-weight: 500;
//   }

//   .schedule-edit-dropdown .ant-select-item-option-active {
//     background-color: rgba(198, 194, 255, 0.6) !important;
//   }

//   .schedule-edit-dropdown .ant-select-item {
//     border-radius: 8px;
//     margin: 4px;
//   }

//   /* =========================
//      REMOVE ANT DESIGN EXTRA LINES
//      (DO NOT TOUCH YOUR BORDERS)
//   ========================== */

//   /* Input wrapper borders */
//   .ant-input-affix-wrapper,
//   .ant-input-affix-wrapper-focused,
//   .ant-input-affix-wrapper:hover {
//     border: none !important;
//     box-shadow: none !important;
//   }

//   .ant-input-affix-wrapper::before,
//   .ant-input-affix-wrapper::after {
//     display: none !important;
//   }

//   /* DatePicker / TimePicker borders */
//   .ant-picker,
//   .ant-picker-focused,
//   .ant-picker:hover {
//     border: none !important;
//     box-shadow: none !important;
//     background: transparent !important;
//   }

//   .ant-picker::before,
//   .ant-picker::after {
//     display: none !important;
//   }
// `}
// </style>


//       {/* Mode of Class */}
//       <div style={{ marginBottom: 24 }}>
//         <div
//           style={{
//             fontSize: 16,
//             color: '#6B6B6B',
//             marginBottom: 12,
//             fontWeight: 500,
//           }}
//         >
//           Mode of class <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
//         </div>

//         <div style={{ display: 'flex', gap: 10 }}>
//           {['Broadcast', 'Offline', 'Others'].map((m) => (
//             <div
//               key={m}
//               onClick={() => setMode(m)}
//               style={{
//                 width: 109,
//                 height: 35,
//                 padding: '8px 32px',
//                 borderRadius: 12,
//                 border: mode === m ? '1px solid #C6C2FF' : '1px solid #E6E6E6',
//                 background: mode === m ? '#C6C2FF' : '#FFFFFF',
//                 color: mode === m ? '#191919' : '#6B6B6B',
//                 fontSize: 18,
//                 fontWeight: 500,
//                 cursor: 'pointer',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 transition: 'all 0.2s ease',
//               }}
//             >
//               {m}
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Date Fields */}
//       <div style={{ display: 'flex', gap: 16, marginBottom: 24 }}>
//         <div style={{ flex: 1 }}>
//           <div style={{ 
//             fontSize: 16, 
//             color: '#6B6B6B', 
//             marginBottom: 8,
//             fontWeight: 500
//           }}>
//             Start date <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
//           </div>
//           <div style={{  paddingBottom: 8 }}>
//             <div onMouseEnter={() => setHoverStartDate(true)} onMouseLeave={() => setHoverStartDate(false)}>
//             <DatePicker
//                 value={startDate ? moment(startDate, 'YYYY-MM-DD') : null}
//                 format={formatDate}
//                 onChange={onChangeStartDate}
//                 style={pickerStyle}
//                 inputReadOnly
//                 bordered={false}
//                 disabledDate={disabledStartDate}
//                 suffixIcon={(startDate && hoverStartDate) ? null : <img src={calenderIcon} alt="calendar" style={{ width: 24, height: 24 }} />}
//                 allowClear={true}
//                 placeholder="DD/MM/YYYY"
//               />
//             </div>
//           </div>
//           <div style={{ width: '244px', height: '0px', borderTop: '1px solid #E6E6E6', opacity: 1 }} />
//         </div>
//         <div style={{ flex: 1 }}>
//           <div style={{ 
//             fontSize: 16, 
//             color: '#6B6B6B', 
//             marginBottom: 8,
//             fontWeight: 500
//           }}>
//             Last date <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
//           </div>
//           <div style={{  paddingBottom: 8 }}>
//             <div onMouseEnter={() => setHoverEndDate(true)} onMouseLeave={() => setHoverEndDate(false)}>
//             <DatePicker
//               value={endDate ? moment(endDate, 'YYYY-MM-DD') : null}
//               format={formatDate}
//               onChange={onChangeLastDate}
//               style={pickerStyle}
//               inputReadOnly
//               bordered={false}
//               disabled={!startDate}
//               disabledDate={disabledDate}
//               suffixIcon={(endDate && hoverEndDate) ? null : <img src={calenderIcon} alt="calendar" style={{ width: 24, height: 24 }} />}
//               allowClear={true}
//               placeholder="DD/MM/YYYY"
//             />
//             </div>
//           </div>
//           <div style={{ width: '244px', height: '0px', borderTop: '1px solid #E6E6E6', opacity: 1 }} />
//         </div>
//       </div>

//       {/* Time Fields */}
//       <div style={{ display: 'flex', gap: 16, marginBottom: 24 }}>
//         <div style={{ flex: 1 }}>
//           <div style={{ 
//             fontSize: 16, 
//             color: '#6B6B6B', 
//             marginBottom: 8,
//             fontWeight: 500
//           }}>
//             Start time <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
//           </div>
//           <div style={{  paddingBottom: 8 }}>
//             <div onMouseEnter={() => setHoverStartTime(true)} onMouseLeave={() => setHoverStartTime(false)}>
//               <TimePicker
//               value={startTime ? moment(startTime, 'HH:mm') : null}
//               format={format}
//               onChange={onChangeStartTime}
//               style={pickerStyle}
//               inputReadOnly
//               bordered={false}
//               disabled={!(startDate && endDate)}
//               disabledHours={() => disabledStartTimeHours()}
//               disabledMinutes={disabledStartTimeMinutes}
//               suffixIcon={(startTime && hoverStartTime) ? null : <img src={clockIcon} alt="clock" style={{ width: 24, height: 24 }} />}
//               allowClear={true}
//               placeholder={'select start time'}
//             />
//             </div>
//           </div>
//           <div style={{ width: '244px', height: '0px', borderTop: '1px solid #E6E6E6', opacity: 1 }} />
//         </div>
//         <div style={{ flex: 1 }}>
//           <div style={{ 
//             fontSize: 16, 
//             color: '#6B6B6B', 
//             marginBottom: 8,
//             fontWeight: 500
//           }}>
//             End time <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
//           </div>
//           <div style={{ paddingBottom: 8 }}>
//             <div onMouseEnter={() => setHoverEndTime(true)} onMouseLeave={() => setHoverEndTime(false)}>
//             <TimePicker
//               value={endTime ? moment(endTime, 'HH:mm') : null}
//               format={format}
//               onChange={onChangeEndTime}
//               style={pickerStyle}
//               inputReadOnly
//               bordered={false}
//               disabled={!startTime}
//               disabledHours={() => disabledEndTimeHours()}
//               disabledMinutes={disabledEndTimeMinutes}
//               suffixIcon={(endTime && hoverEndTime) ? null : <img src={clockIcon} alt="clock" style={{ width: 24, height: 24 }} />}
//               allowClear={true}
//               placeholder={'select end time'}
//             />
//             </div>
//           </div>
//           <div style={{ width: '244px', height: '0px', borderTop: '1px solid #E6E6E6', opacity: 1 }} />
//         </div>
//       </div>

//       {/* Repeat On */}
//       <div style={{ marginBottom: 32 }}>
//         <div style={{ 
//           fontSize: 16, 
//           color: '#6B6B6B', 
//           marginBottom: 12,
//           fontWeight: 500
//         }}>
//           Repeat on <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
//         </div>
//         <div style={{ display: 'flex', gap: 12, justifyContent: 'space-between' }}>
//           {['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].map((d, i) => {
//             const dayMap = ['Su','M','T','W','Th','F','S']
//             return (
//               <div 
//                 key={d} 
//                 onClick={() => handleDaysButtonColor(dayMap[i], colorDays[i])} 
//                 style={{
//                   width: 56,
//                   height: 56,
//                   borderRadius: '50%',
//                   background: colorDays[i] ? '#C6C2FF' : '#FFFFFF',
//                   border: colorDays[i] ? 'none' : '1px solid #E6E6E6',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   fontSize: 18,
//                   fontWeight: 500,
//                   color: '#594099',
//                   cursor: 'pointer',
//                   transition: 'all 0.2s ease'
//                 }}
//               >
//                 {d}
//               </div>
//             )
//           })}
//         </div>
//       </div>

//       {/* Action Buttons */}
//       <div style={{ 
//         display: 'flex', 
//         justifyContent: 'space-between', 
//         gap: 10,
//         marginTop: 150
//       }}>
//           <button 
//             onClick={() => {
//               if (initialFormState) {
//                 setSubName(initialFormState.subName)
//                 setSubject(initialFormState.subId)
//                 setClass(initialFormState.classId)
//                 setClassNameArr(initialFormState.classNameArr)
//                 setClassName('')
//                 setTeacherName(initialFormState.teacherName)
//                 setTeacher(initialFormState.teacherId)
//                 setStartTime(initialFormState.startTime)
//                 setEndTime(initialFormState.endTime)
//                 setSartDate(initialFormState.startDate)
//                 setEndDate(initialFormState.endDate)
//                 setMode(initialFormState.mode)
//                 setWeekDays(initialFormState.weekdays)
//                 setColorDays(initialFormState.colorDays)
//               }
//             }} 
//             disabled={isResetDisabled}
//             style={{
//               width: 140,
//               height: 45,
//               borderRadius: 8,
//               borderWidth: 1,
//               borderStyle: 'solid',
//               borderColor: '#E6E6E6',
//               paddingTop: 13,
//               paddingRight: 32,
//               paddingBottom: 13,
//               paddingLeft: 32,
//               background: '#FFFFFF',
//               color: '#191919',
//               fontSize: 18,
//               fontWeight: 600,
//               cursor: isResetDisabled ? 'default' : 'pointer',
//               letterSpacing: '0.5px',
//               transition: 'all 0.2s ease',
//               opacity: isResetDisabled ? 0.7 : 1
//             }}
//           >
//             RESET
//           </button>

//           <button 
//             onClick={() => { if (isFormValidEdit) setShowSavingModal(true) }} 
//             disabled={saveLoader || !isFormValidEdit}
//             style={{
//               width: 140,
//               height: 45,
//               borderRadius: 8,
//               borderWidth: 1,
//               borderStyle: 'solid',
//               borderColor: 'transparent',
//               paddingTop: 13,
//               paddingRight: 32,
//               paddingBottom: 13,
//               paddingLeft: 32,
//               background: '#594099',
//               color: '#FFFFFF',
//               fontSize: 18,
//               fontWeight: 600,
//               cursor: saveLoader || !isFormValidEdit ? 'default' : 'pointer',
//               letterSpacing: '0.5px',
//               opacity: saveLoader || !isFormValidEdit ? 0.7 : 1,
//               transition: 'all 0.2s ease'
//             }}
//           >
//             SAVE
//           </button>
//       </div>

//       <SavingModal visible={showSavingModal} onCancel={() => setShowSavingModal(false)} onConfirm={() => { setShowSavingModal(false); createSchedule(); }} />
//     </div>
//   )
// }

// const mapStateToProps = (state) => {
//   const { subList, subId, classList, teacherList, weekdays, classId, teacherId, startTime, endTime, startDate, endDate, mode, tabType, stdTimetable, currentDate, subsAlertData } = state.schedule
//   return { subList, subId, classList, teacherList, weekdays, classId, teacherId, startTime, endTime, startDate, endDate, mode, tabType, stdTimetable, currentDate, subsAlertData }
// }

// const mapDispatchToProps = (dispatch) => ({
//   fetchSubList: (s, cb) => dispatch(fetchSubList(s, cb)),
//   fetchClassList: (s, id, cb) => dispatch(fetchClassList(s, id, cb)),
//   fetchTeacherList: (s, cb) => dispatch(fetchTeacherList(s, cb)),
//   setSubject: (id) => dispatch(setSubject(id)),
//   setClass: (ids) => dispatch(setClass(ids)),
//   setTeacher: (id) => dispatch(setTeacher(id)),
//   setStartTime: (t) => dispatch(setStartTime(t)),
//   setEndTime: (t) => dispatch(setEndTime(t)),
//   setSartDate: (d) => dispatch(setSartDate(d)),
//   setEndDate: (d) => dispatch(setEndDate(d)),
//   setMode: (m) => dispatch(setMode(m)),
//   setWeekDays: (w) => dispatch(setWeekDays(w)),
//   postCreateSchedule: (obj, cb, sc) => dispatch(postCreateSchedule(obj, cb, sc)),
//   setScheduleIdDelete: (id) => dispatch(setScheduleIdDelete(id)),
//   fetchSchedule: (cb, date) => dispatch(fetchSchedule(cb, date)),
//   fetchTimetableData: (id, cb) => dispatch(fetchTimetableData(id, cb)),
//   fetchScheduleFilter: (date, topic, std, sub, cb) => dispatch(fetchScheduleFilter(date, topic, std, sub, cb)),
//   setDelOrCancel: (v) => dispatch(setDelOrCancel(v)),
//   setSubscriptionModal: (v) => dispatch(setSubscriptionModal(v)),
//   setCurrentDate: (date) => dispatch(setCurrentDate(date)),
// })

// export default connect(mapStateToProps, mapDispatchToProps)(ScheduleEditTab)

import React, { useEffect, useState, useRef } from "react";
import ReactDOM from 'react-dom';
import { connect } from 'react-redux'
import { AutoComplete, Input, DatePicker, TimePicker, message, Tooltip, Spin } from 'antd'
import moment from "moment";
import { fetchClassList, fetchSubList, fetchTeacherList, postCreateSchedule, postEditOccurance, setClass, setEndTime, setMode, setSartDate, setEndDate, setStartTime, setSubject, setTeacher, setWeekDays, setScheduleIdDelete, fetchTimetableData, fetchSchedule, setDelOrCancel, setCurrentDate, fetchScheduleFilter, setSubscriptionModal } from 'actions/schedule'
import { EventRegister } from 'react-native-event-listeners'
import SavingModal from 'components/SavingModal'
import { Notification } from 'services'
import PageDataLoader from 'components/pageDataLoader'

import calenderIcon from "../../Assets/schedule/calendar.svg";
import deleteIcon from "../../Assets/schedule/delete.svg";
import clockIcon from "../../Assets/schedule/clock.svg";
import downArrowIcon from "../../Assets/schedule/downArrow.svg";
import upArrowIcon from "../../Assets/schedule/upArrow.svg";

// See CreateScheduleDrawer.js's getResponsiveFieldGap - same fix, same reasoning: shrinks
// the gap between fields at higher zoom (keyed off window.outerHeight, unaffected by zoom)
// so the form's total content height is more likely to actually fit within the scroll
// container's box, leaving nothing to spill into the footer when a date/time popup
// temporarily lifts that container's clip.
const getResponsiveFieldGap = () => {
    const oh = typeof window !== 'undefined' && window.outerHeight ? window.outerHeight : 1080
    if (oh <= 700) return 12
    if (oh <= 850) return 16
    if (oh <= 950) return 20
    return 24
}

const ScheduleEditTab = ({
    schedule,
    // redux state + actions
    subList, subId, classList, teacherList, weekdays, classId, teacherId, startTime, endTime, startDate, endDate, mode,
    fetchSubList, fetchClassList, fetchTeacherList, setSubject, setClass, setTeacher, setStartTime, setEndTime, setSartDate, setEndDate, setMode, setWeekDays,
    postCreateSchedule, postEditOccurance, fetchSchedule, fetchTimetableData, fetchScheduleFilter, setScheduleIdDelete, setDelOrCancel, setSubscriptionModal, subsAlertData, tabType, stdTimetable, currentDate, teacherSearch, classFilter, subFilter,
    setCurrentDate, editType, onCancel = () => { }, onSave = () => { }, togglePageLoader, pageLoader
}) => {
    // EDIT THIS CLASS edits a single occurrence; EDIT SCHEDULE edits the recurring series
    // behind it. The two must not read from the same place. An occurrence carries its own
    // overrides - a time moved for one day, a stand-in teacher - while the series carries
    // the pattern those occurrences are generated from.
    //
    // This used to merge both with the series spread LAST, so the series won for every
    // field it happened to carry and the occurrence won for the rest, whichever button had
    // been pressed. That left EDIT SCHEDULE showing an occurrence's one-off edits back to
    // the user as if they were the series' own values - and saving from there would have
    // written a single day's override across the whole series.
    //
    // Spreading undefined over a value still clobbers it, so the overriding side is
    // stripped of undefined keys first: a series that simply doesn't carry a field must
    // fall back to the occurrence's, not blank it.
    const definedOnly = (obj) => Object.fromEntries(
        Object.entries(obj || {}).filter(([, value]) => value !== undefined)
    );

    const occurrence = schedule || {};
    const series = schedule?.schedule || {};
    // Whichever of the two this form is actually editing wins every field it defines.
    const primary = editType === 'occurrence' ? occurrence : series;
    const fallback = editType === 'occurrence' ? series : occurrence;

    const data = {
        ...fallback,
        ...definedOnly(primary),
        subject: primary?.subject || fallback?.subject,
        teacher: primary?.teacher || fallback?.teacher,
        standards: primary?.standards?.length ? primary.standards : (fallback?.standards || [])
    };

    if (!schedule || (!data?.id && !data?.scheduleId && !data?.subject?.id && !data?.subject?.name)) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: 300 }}>
                <Spin size="large" />
            </div>
        );
    }

    const initialSubjectName = data?.subject?.name || ''
    const initialSubjectId = data?.subject?.id || null
    const initialCls = (data?.standards || []).map(i => ({ id: i.id, name: `${i.std} : ${i.section}` }))
    const initialClsIds = initialCls.map(c => c.id)
    const initialTeacherName = data?.teacher?.name || ''
    const initialTeacherId = data?.teacher?.id || null
    const initialSt = data?.startTime ? (data.startTime.length === 5 ? data.startTime : moment(data.startTime, 'HH:mm:ss').format('HH:mm')) : ''
    const initialEt = data?.endTime ? (data.endTime.length === 5 ? data.endTime : moment(data.endTime, 'HH:mm:ss').format('HH:mm')) : ''
    const initialWd = data?.weekdays || []
    const initialColorDays = [false, false, false, false, false, false, false]
    initialWd.forEach(d => {
        if (d === 'sunday') initialColorDays[0] = true
        if (d === 'monday') initialColorDays[1] = true
        if (d === 'tuesday') initialColorDays[2] = true
        if (d === 'wednesday') initialColorDays[3] = true
        if (d === 'thursday') initialColorDays[4] = true
        if (d === 'friday') initialColorDays[5] = true
        if (d === 'saturday') initialColorDays[6] = true
    })

    const [colorDays, setColorDays] = useState(initialColorDays)
    const [optionSub, setOptionsSub] = useState([])
    const [optionClass, setOptionsClass] = useState([])
    const [optionTeacher, setOptionsTeacher] = useState([])
    const [cachedSubList, setCachedSubList] = useState(null)
    const [cachedClassList, setCachedClassList] = useState(null)
    const [cachedTeacherList, setCachedTeacherList] = useState(null)
    const [subName, setSubName] = useState(initialSubjectName)
    const [className, setClassName] = useState('')
    const [teacherName, setTeacherName] = useState(initialTeacherName)
    const [classNameArr, setClassNameArr] = useState(initialCls)
    const [buttonColor, setButtonColor] = useState([false, false, false, false, false])
    const [subjectLoader, setSubjectLoader] = useState(false)
    const [stdLoader, setStdLoader] = useState(false)
    const [teacherLoader, setTeacherLoader] = useState(false)
    const [showSavingModal, setShowSavingModal] = useState(false)
    const [scheduleId, setScheduleId] = useState(data?.scheduleId || data?.id || null)
    const [accessEdit, setAccessEdit] = useState(false)
    const [showBatchInput, setShowBatchInput] = useState(false)
    const [subjectDropdownOpen, setSubjectDropdownOpen] = useState(false)
    const [teacherDropdownOpen, setTeacherDropdownOpen] = useState(false)
    const [batchDropdownOpen, setBatchDropdownOpen] = useState(false)
    const [isSearchingSub, setIsSearchingSub] = useState(false)
    const [isSearchingTeacher, setIsSearchingTeacher] = useState(false)
    const [subFocused, setSubFocused] = useState(false)
    const [batchFocused, setBatchFocused] = useState(false)
    const [teacherFocused, setTeacherFocused] = useState(false)
    const [startDateFocused, setStartDateFocused] = useState(false)
    const [endDateFocused, setEndDateFocused] = useState(false)
    const [startTimeFocused, setStartTimeFocused] = useState(false)
    const [endTimeFocused, setEndTimeFocused] = useState(false)
    const [suppressSubOptionsUpdate, setSuppressSubOptionsUpdate] = useState(false)
    const [initialFormState, setInitialFormState] = useState(null)
    // Which class the prefill effect below has actually finished writing. Subject,
    // batch, teacher, dates and times all live in redux, which still holds the
    // previously edited class when this mounts — so without this the form's first
    // paint showed blank or stale fields before snapping to the right ones.
    const [prefilledKey, setPrefilledKey] = useState(null)
    const subRef = useRef(null)
    const instructorRef = useRef(null)
    const startDateRef = useRef(null)
    const endDateRef = useRef(null)
    const startTimeRef = useRef(null)
    const endTimeRef = useRef(null)
    // Plain DOM refs on each date/time field's own wrapper, used only to scroll that field
    // into view when its picker opens - antd's DatePicker/TimePicker ref (above) exposes
    // focus/blur, not the DOM node, so it can't be used for this.
    const startDateWrapRef = useRef(null)
    const endDateWrapRef = useRef(null)
    const startTimeWrapRef = useRef(null)
    const endTimeWrapRef = useRef(null)
    const isManualClearRef = useRef(false)
    const [hoverStartDate, setHoverStartDate] = useState(false)
    const [hoverEndDate, setHoverEndDate] = useState(false)
    const [hoverStartTime, setHoverStartTime] = useState(false)
    const [hoverEndTime, setHoverEndTime] = useState(false)

    const [fieldGap, setFieldGap] = useState(getResponsiveFieldGap);
    useEffect(() => {
        const onResize = () => setFieldGap(getResponsiveFieldGap());
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    // Scrolls a date/time field to the top of the scroll container when its picker opens,
    // maximizing the room left below for the popup (which opens downward, in normal flow,
    // inside the always-clipping scroll container - no more toggling overflow to 'visible'
    // to let it render over the footer instead). If the popup still doesn't fully fit, the
    // container's own scrollbar - not an overlap onto the footer - is what shows the rest.
    const scrollFieldIntoView = (wrapRef) => {
        setTimeout(() => {
            wrapRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }, 0)
    }

    const format = 'hh:mm A'
    const formatDate = "DD/MM/YYYY"

    const pickerStyle = {
        width: '100%',
        height: 28,
        border: 'none',
        background: 'transparent',
        padding: 0,
        boxShadow: 'none',
        outline: 'none',
    };

    // Keyed on the occurrence's own id (not the `data` object reference) so this
    // pre-fill only (re)runs when the user starts editing a *different* class.
    // Using `[data]` previously meant the 30s background poll in scheduleAdmin.js
    // (which refetches today's schedule list and hands down a fresh `schedule`
    // object with the same id) re-ran this effect mid-edit and silently reverted
    // any date/time/etc. changes the user hadn't saved yet.
    // Keyed on the edit mode as well as the class: the prefill below writes the form's
    // fields into redux, where they outlive this component, and occurrence and series hold
    // different values for the same class. Without the mode in the key, going from one
    // form straight to the other for the same class would leave the first one's values
    // sitting in the fields.
    const editingScheduleKey = `${editType === 'occurrence' ? 'occurrence' : 'schedule'}:${data?.scheduleId || data?.id}`;
    useEffect(() => {
        const subjectName = data?.subject?.name || ''
        const subjectId = data?.subject?.id
        const cls = (data?.standards || []).map(i => ({ id: i.id, name: `${i.std} : ${i.section}` }))
        const clsIds = cls.map(c => c.id)
        const teacherNameValue = data?.teacher?.name || ''
        const teacherIdValue = data?.teacher?.id
        const st = data?.startTime ? (data.startTime.length === 5 ? data.startTime : moment(data.startTime, 'HH:mm:ss').format('HH:mm')) : ''
        const et = data?.endTime ? (data.endTime.length === 5 ? data.endTime : moment(data.endTime, 'HH:mm:ss').format('HH:mm')) : ''
        const wd = data?.weekdays || []
        const newColor = [false, false, false, false, false, false, false]
        wd.forEach(d => {
            if (d === 'sunday') newColor[0] = true
            if (d === 'monday') newColor[1] = true
            if (d === 'tuesday') newColor[2] = true
            if (d === 'wednesday') newColor[3] = true
            if (d === 'thursday') newColor[4] = true
            if (d === 'friday') newColor[5] = true
            if (d === 'saturday') newColor[6] = true
        })

        // Set all form values from current schedule data
        setSubName(subjectName)
        setSubject(subjectId)
        setClass(clsIds)
        setClassNameArr(cls)
        setClassName('')
        setTeacherName(teacherNameValue)
        setTeacher(teacherIdValue)
        setStartTime(st)
        setEndTime(et)
        setSartDate(data?.startDate)
        setEndDate(data?.endDate)
        setMode(data?.mode)
        setScheduleId(data?.scheduleId || data?.id)
        setWeekDays(wd)
        setColorDays(newColor)

        setInitialFormState({
            subName: subjectName,
            subId: subjectId,
            classId: clsIds,
            classNameArr: cls,
            teacherName: teacherNameValue,
            teacherId: teacherIdValue,
            startTime: st,
            endTime: et,
            startDate: data?.startDate,
            endDate: data?.endDate,
            mode: data?.mode,
            weekdays: wd,
            colorDays: newColor
        })

        // Note: accessEdit is now handled by a dedicated useEffect observing startDate/startTime/endTime

        // Fetch class list for already selected subject so ADD BATCH visibility can be derived
        if (subjectId) {
            setCachedClassList(null) // Start with a fresh cache
            fetchClassList('', subjectId)
        }

        // Every field for this class has now been written — the form is safe to show.
        setPrefilledKey(editingScheduleKey)
    }, [editingScheduleKey])

    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
        const drawerBody = document.querySelector('.ant-drawer-body');
        if (drawerBody) {
            drawerBody.scrollTo(0, 0);
        }
    }, []);

    // Re-evaluate editing access if the user changes the form's date or time
    // or based on editType ('occurrence' vs 'schedule')
    useEffect(() => {
        // "for EDIT TODAY'S CLASS never show it never"
        if (editType === 'occurrence') {
            setAccessEdit(false);
            return;
        }

        const todayDate = moment().format('YYYY-MM-DD');
        const currentTime = moment().format('HH:mm');
        const currentWeekday = moment().format('dddd').toLowerCase();
        
        // Normalize startDate just in case it comes in as DD/MM/YYYY
        let normalizedStartDate = startDate;
        if (startDate && startDate.indexOf('/') !== -1) {
            normalizedStartDate = moment(startDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }

        let normalizedEndDate = endDate;
        if (endDate && endDate.indexOf('/') !== -1) {
            normalizedEndDate = moment(endDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }

        // "show it when EDITING AN ENTIRE SCHEDULE for future dates too"
        // Check if the series is actively ongoing right now.
        // 1. Is today between the series start and end date?
        const isDateInRange = normalizedStartDate && normalizedEndDate && 
            todayDate >= normalizedStartDate && todayDate <= normalizedEndDate;

        // 2. Does the series repeat on today's weekday?
        const currentWeekdays = (Array.isArray(weekdays) && weekdays.length > 0) ? weekdays : (data?.weekdays || []);
        const isRepeatingToday = currentWeekdays.includes(currentWeekday);

        if (isDateInRange && isRepeatingToday) {
            const startT = startTime ? moment(startTime, 'HH:mm:ss').format('HH:mm') : null;
            const endT = endTime ? moment(endTime, 'HH:mm:ss').format('HH:mm') : null;
            
            if (startT && endT && currentTime >= startT && currentTime <= endT) {
                setAccessEdit(true);
            } else {
                setAccessEdit(false);
            }
        } else {
            setAccessEdit(false);
        }
    }, [startDate, endDate, startTime, endTime, weekdays, editType, data]);

    useEffect(() => {
        // Update options whenever data changes or search string updates
        if (suppressSubOptionsUpdate) return

        const currentSubName = subList?.find(s => s.id === subId)?.name || ''
        const isSearchActive = subName !== currentSubName || isSearchingSub

        const opts = subList ? subList.filter(item =>
            !isSearchActive || item.name.toLowerCase().includes(subName.toLowerCase())
        ).map((item, index) => ({
            key: index,
            value: item.name,
            label: item.name,
            id: item.id,
            className: item.id === subId ? 'custom-selected-option' : ''
        })) : []
        // Only set the 'No subject found' placeholder when user has typed a query
        if ((!opts || opts.length === 0) && isSearchActive && subName) {
            setOptionsSub([{ key: 'no-data', value: 'no-data', label: 'No subject found', disabled: true }])
        } else {
            setOptionsSub(opts)
        }
        if (!subName) setCachedSubList(subList)
    }, [subList, subName, suppressSubOptionsUpdate, subjectDropdownOpen, subId, isSearchingSub])

    useEffect(() => {
        const selectedIds = Array.isArray(classId) ? classId : []
        const available = classList ? classList.filter(c => !selectedIds.includes(c.id)) : []
        const opts = available.map((item, index) => ({ key: index, value: `${item.std} : ${item.section}`, label: `${item.std} : ${item.section}`, id: item.id }))
        if ((!opts || opts.length === 0)) {
            setOptionsClass([{ key: 'no-data', value: 'no-data', label: 'No batch found', disabled: true }])
        } else {
            setOptionsClass(opts)
        }
        if (!className) setCachedClassList(classList)
    }, [classList, className, classId])

    useEffect(() => {
        const currentTeacherName = teacherList?.find(t => t.id === teacherId)?.name || ''
        const isSearchActive = teacherName !== currentTeacherName || isSearchingTeacher

        const opts = teacherList ? teacherList.filter(item =>
            !isSearchActive || item.name.toLowerCase().includes(teacherName.toLowerCase())
        ).map((item, index) => ({
            key: index,
            value: item.name,
            label: item.name,
            id: item.id,
            className: item.id === teacherId ? 'custom-selected-option' : ''
        })) : []
        if ((!opts || opts.length === 0) && isSearchActive && teacherName) {
            setOptionsTeacher([{ key: 'no-data', value: 'no-data', label: 'No instructor found', disabled: true }])
        } else {
            setOptionsTeacher(opts)
        }
        if (!teacherName) setCachedTeacherList(teacherList)
    }, [teacherList, teacherName, teacherId, isSearchingTeacher])

    useEffect(() => {
        fetchSubList()
        fetchTeacherList('')
    }, [])

    const handleSearchTeacher = (value) => {
        if (!value) {
            setTeacherName('')
            setIsSearchingTeacher(false)
            setTeacher(null)
        }
        else {
            setTeacherName(value);
            setTeacherLoader(true);
            setIsSearchingTeacher(true)
            setTeacher(null)
        }
        fetchTeacherList(value, () => setTeacherLoader(false))
    }

    const handleSearchSub = (value) => {
        if (!value) {
            setSubName('')
            setIsSearchingSub(false)
            setSubject(null)
            setClass([])
            setClassNameArr([])
            setShowBatchInput(false)
        }
        else {
            setSubName(value);
            setSubjectLoader(true);
            setIsSearchingSub(true)
            setSubject(null)
            setClass([])
            setClassNameArr([])
            setShowBatchInput(false)
        }
        fetchSubList(value, () => setSubjectLoader(false))
    }

    const onSelectSub = (value, option) => {
        setIsSearchingSub(false)
        if (!value || value === 'no-data') return
        const id = option?.id || (subList && subList.find(s => s.name === value)?.id)
        if (id) {
            setSubject(id)
            setSubName(value)
            setClass([])
            setClassNameArr([])
            setShowBatchInput(false)
            setCachedClassList(null) // Clear cache immediately to hide button while loading
            fetchClassList('', id)
        } else {
            setSubject(null)
            setSubName('')
            setClass([])
            setClassNameArr([])
            setShowBatchInput(false)
            setBatchFocused(false)
        }
    }

    const handleSearchClass = (value) => {
        if (value) { setClassName(value); setStdLoader(true); fetchClassList(value, subId, () => setStdLoader(false)) }
        else { setClassName(''); fetchClassList('', subId, () => setStdLoader(false)) }
    }

    const onSelectClass = (value, option) => {
        if (!value || value === 'no-data') return
        const id = option?.id || (classList && classList.find(c => `${c.std} : ${c.section}` === value)?.id)
        if (id) {
            const newClassIds = Array.isArray(classId) ? [...classId] : []
            const newClassNameArr = Array.isArray(classNameArr) ? [...classNameArr] : []
            if (!newClassIds.includes(id)) {
                newClassIds.push(id)
                newClassNameArr.push({ id: id, name: value })
                setClass(newClassIds)
                setClassNameArr(newClassNameArr)
            }
            setClassName('')

            const remainingBatches = (classList || []).filter(c => !newClassIds.includes(c.id))
            if (remainingBatches.length > 0) {
                setShowBatchInput(false)
                setBatchDropdownOpen(false)
            } else {
                setShowBatchInput(false)
                setBatchDropdownOpen(false)
            }

            fetchTeacherList('')
        } else {
            setClass([]); setClassName(''); setClassNameArr([]); setTeacher(null); setTeacherName('')
        }
    }

    const onSelectTeacher = (value, option) => {
        setIsSearchingTeacher(false)
        if (!value || value === 'no-data') return
        const id = option?.id || (teacherList && teacherList.find(t => t.name === value)?.id)
        if (id) {
            setTeacher(id)
            setTeacherName(value)
        } else { setTeacher(null); setTeacherName('') }
    }

    const currentMode = (mode !== undefined && mode !== null && mode !== '') ? mode : (data?.mode || '')
    const currentStartDate = (startDate !== undefined && startDate !== null) ? startDate : (data?.startDate || '')
    const currentEndDate = (endDate !== undefined && endDate !== null) ? endDate : (data?.endDate || '')
    const currentStartTime = (startTime !== undefined && startTime !== null) ? startTime : initialSt
    const currentEndTime = (endTime !== undefined && endTime !== null) ? endTime : initialEt
    const currentSubId = subId || initialSubjectId
    const currentTeacherId = teacherId || initialTeacherId
    const currentClassIds = (Array.isArray(classId) && classId.length > 0) ? classId : initialClsIds
    const currentWeekdays = (Array.isArray(weekdays) && weekdays.length > 0) ? weekdays : initialWd

    const handleDaysButtonColor = (value, active) => {
        let newWeekdays = Array.isArray(weekdays && weekdays.length > 0 ? weekdays : currentWeekdays) ? [...(weekdays && weekdays.length > 0 ? weekdays : currentWeekdays)] : []
        const newColor = [...colorDays]
        const toggleDay = (index, dayName) => {
            newColor[index] = !active
            if (newColor[index]) { if (!newWeekdays.includes(dayName)) newWeekdays.push(dayName) }
            else { newWeekdays = newWeekdays.filter((w) => w !== dayName) }
            setColorDays(newColor)
        }
        if (value == "Su") toggleDay(0, 'sunday')
        else if (value == "M") toggleDay(1, 'monday')
        else if (value == "T") toggleDay(2, 'tuesday')
        else if (value == "W") toggleDay(3, 'wednesday')
        else if (value == "Th") toggleDay(4, 'thursday')
        else if (value == "F") toggleDay(5, 'friday')
        else if (value == "S") toggleDay(6, 'saturday')
        setWeekDays(newWeekdays)
    }

    const onChangeStartDate = (date) => {
        if (date) {
            setSartDate(date.format('YYYY-MM-DD'))
        } else {
            setSartDate('')
            setStartDateFocused(false)
            startDateRef.current?.blur()
        }
    }

    const onChangeLastDate = (date) => {
        if (date) {
            setEndDate(date.format('YYYY-MM-DD'))
        } else {
            setEndDate('')
            setEndDateFocused(false)
            endDateRef.current?.blur()
        }
    }

    const onChangeStartTime = (time, timestring) => {
        setEndTime('')
        if (time) {
            const timestring24 = moment(time, format).format('HH:mm')
            if (currentMode === 'Zoom 40') {
                const end = moment(timestring24, 'HH:mm').add(40, 'minutes')
                setEndTime(end.format('HH:mm'))
            }
            setStartTime(timestring24)
        } else {
            setStartTime('')
            setStartTimeFocused(false)
            startTimeRef.current?.blur()
        }
    }

    const onChangeEndTime = (time, timestring) => {
        if (time) setEndTime(moment(time, format).format('HH:mm'))
        else {
            setEndTime('')
            setEndTimeFocused(false)
            endTimeRef.current?.blur()
        }
    }

    const isFormValidEdit = Boolean(
        (scheduleId || data?.scheduleId || data?.id) &&
        currentSubId &&
        currentStartTime &&
        currentEndTime &&
        currentStartDate &&
        currentEndDate &&
        currentMode &&
        Array.isArray(currentClassIds) &&
        currentClassIds.length !== 0 &&
        currentTeacherId &&
        Array.isArray(currentWeekdays) &&
        currentWeekdays.length !== 0
    )

    const onClose = (value) => {
        const newClassNameArr = classNameArr.filter((item) => item.id != value)
        const newClassIds = (Array.isArray(classId && classId.length > 0 ? classId : initialClsIds) ? (classId && classId.length > 0 ? classId : initialClsIds) : []).filter((item) => item != value)
        setClass(newClassIds)
        setClassNameArr(newClassNameArr)
        setClassName('')

        if (newClassNameArr.length === 0) {
            setShowBatchInput(false)
            setBatchFocused(false)
        }
    }

    const disabledStartDate = (current) => {
        if (!current) return false
        return current.isBefore(moment().startOf('day'))
    }

    const disabledDate = (current) => {
        if (!current) return false
        const beforeToday = current.isBefore(moment().startOf('day'))
        if (currentStartDate) {
            const beforeStart = current.isBefore(moment(currentStartDate, 'YYYY-MM-DD').startOf('day'))
            return beforeToday || beforeStart
        }
        return beforeToday
    }

    // Only a class happening TODAY can have times that are already past. This used to
    // also return true whenever today merely fell somewhere inside the schedule's date
    // range, which is the normal state of any recurring series that started earlier and
    // runs on - so editing an occurrence on a future date had this morning's hours greyed
    // out for no reason. A future date has no past hours; neither does a series whose slot
    // simply began before today.
    // Restore this to go back to disabling across the whole range:
    //   if (currentStartDate && currentEndDate) {
    //     const today = moment().startOf('day')
    //     const start = moment(currentStartDate, 'YYYY-MM-DD').startOf('day')
    //     const end = moment(currentEndDate, 'YYYY-MM-DD').startOf('day')
    //     if (today.isAfter(start) && today.isSameOrBefore(end)) return true
    //   }
    const shouldDisablePastTimes = () => {
        // If they accessed this edit menu by clicking on a future date in the timetable,
        // we should not restrict the time picker based on today's time.
        const clickedDateStr = currentDate ? moment(currentDate, 'DD MMM YYYY').format('YYYY-MM-DD') : null;
        if (clickedDateStr && clickedDateStr > moment().format('YYYY-MM-DD')) {
            return false;
        }

        return currentStartDate === moment().format('YYYY-MM-DD')
    }

    const disabledStartTimeHours = () => {
        const hours = []
        if (shouldDisablePastTimes()) {
            for (let i = 0; i < moment().hour(); i++) hours.push(i)
        }
        return hours
    }

    const disabledStartTimeMinutes = (selectedHour) => {
        const minutes = []
        if (selectedHour === moment().hour() && shouldDisablePastTimes()) {
            for (let i = 0; i <= (moment().minute() + 1); i++) minutes.push(i)
        }
        return minutes
    }

    const disabledEndTimeHours = () => {
        const hours = []
        if (currentStartTime) {
            const startHour = moment(currentStartTime, 'HH:mm').hour()
            for (let i = 0; i < startHour; i++) hours.push(i)
        }
        return hours
    }

    const disabledEndTimeMinutes = (selectedHour) => {
        const minutes = []
        if (selectedHour === moment().hour() && shouldDisablePastTimes()) {
            for (let i = 0; i < (moment(currentStartTime, 'HH:mm').minutes() + 1); i++) minutes.push(i)
        } else if (currentStartTime && selectedHour === moment(currentStartTime, 'HH:mm').hour()) {
            for (let i = 0; i < (moment(currentStartTime, 'HH:mm').minutes() + 1); i++) minutes.push(i)
        }
        return minutes
    }

    const createSchedule = () => {
        const today = moment().startOf('day')
        const finalStartDate = currentStartDate
        const finalEndDate = currentEndDate
        const finalStartTime = currentStartTime
        const finalEndTime = currentEndTime
        const finalMode = currentMode
        const finalScheduleId = scheduleId || data?.scheduleId || data?.id
        const finalTeacherId = currentTeacherId
        const finalSubId = currentSubId
        const finalClassIds = currentClassIds
        const finalWeekdays = currentWeekdays

        if (editType !== 'occurrence') {
            if (finalStartDate && moment(finalStartDate, 'YYYY-MM-DD').isBefore(today)) { Notification.error('Error', 'Start date cannot be in the past'); return }
            if (finalEndDate && moment(finalEndDate, 'YYYY-MM-DD').isBefore(today)) { Notification.error('Error', 'End date cannot be in the past'); return }
            if (finalStartDate && finalEndDate && moment(finalEndDate, 'YYYY-MM-DD').isBefore(moment(finalStartDate, 'YYYY-MM-DD'))) { Notification.error('Error', 'End date cannot be before start date'); return }
        }

        const isValidForOccurrence = editType === 'occurrence' && finalSubId && finalStartTime && finalEndTime && finalMode && (finalClassIds && finalClassIds.length !== 0) && finalTeacherId;
        const isValidForSchedule = editType !== 'occurrence' && finalScheduleId && finalSubId && finalStartTime && finalEndTime && finalStartDate && finalEndDate && finalMode && (finalClassIds && finalClassIds.length !== 0) && finalTeacherId && finalWeekdays && finalWeekdays.length !== 0;

        if (isValidForOccurrence || isValidForSchedule) {
            if ((finalMode !== 'Offline' && finalMode !== 'Others') && ((subsAlertData?.totalUserHours == 0) || (subsAlertData?.userHoursUsed >= subsAlertData?.totalUserHours))) {
                setSubscriptionModal(true);
                return;
            }

            const normalize = (t) => t && t.includes(':') ? t.split(':').slice(0, 2).join(':') : t
            
            if (togglePageLoader) togglePageLoader(true)
            if (editType === 'occurrence') {
                const objectOccurance = {
                    id: schedule?.scheduleId 
                        ? schedule?.id 
                        : (schedule?.occurrenceId || schedule?.occuranceId || schedule?.occurrence_id || data?.id),
                    teacherId: finalTeacherId,
                    subjectId: finalSubId,
                    classIds: finalClassIds,
                    startTime: normalize(finalStartTime),
                    endTime: normalize(finalEndTime),
                    mode: finalMode,
                }
                return postEditOccurance(objectOccurance, () => togglePageLoader && togglePageLoader(false), successCallback)
            } else {
                const objectSchedule = {
                    scheduleId: finalScheduleId,
                    teacherId: finalTeacherId,
                    subjectId: finalSubId,
                    classIds: finalClassIds,
                    weekdays: finalWeekdays,
                    startTime: normalize(finalStartTime),
                    endTime: normalize(finalEndTime),
                    mode: finalMode,
                    startDate: finalStartDate,
                    endDate: finalEndDate
                }
                return postCreateSchedule(objectSchedule, () => togglePageLoader && togglePageLoader(false), successCallback)
            }
        } else {
            Notification.error('Error', 'please fill the all information')
        }
    }

    const successCallback = (response) => {
        if (response && response.warnings && response.warnings.length > 0) {
            response.warnings.forEach(warn => {
                Notification.warning('Clash Detected', warn);
            });
        }
        EventRegister.emit('apicall:scheduleHome')

        // Capture what we just tried to save before the resets below clear this state.
        const submittedStartDate = currentStartDate
        const submittedEndDate = currentEndDate
        const verifyScheduleId = scheduleId || data?.scheduleId || data?.id
        const verifyDate = currentDate ? moment(currentDate, 'DD MMM YYYY').format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')

        // Known backend issue: the update endpoint can respond "success" without actually
        // persisting startDate/endDate changes. Re-fetch and compare so the user isn't told
        // the save worked when the date silently reverted.
        if (fetchScheduleFilter && verifyScheduleId) {
            fetchScheduleFilter(verifyDate, teacherSearch, classFilter, subFilter, (response) => {
                if (!response) return
                const allItems = [
                    ...(response.scheduled || []),
                    ...(response.ongoing || []),
                    ...(response.completed || []),
                    ...(response.cancelled || [])
                ]
                const match = allItems.find(it => it.scheduleId === verifyScheduleId || it.schedule?.id === verifyScheduleId)
                const savedStartDate = match?.schedule?.startDate || match?.startDate
                const savedEndDate = match?.schedule?.endDate || match?.endDate
                const mismatches = []
                if (submittedStartDate && savedStartDate && savedStartDate !== submittedStartDate) {
                    mismatches.push(`start date is still ${moment(savedStartDate, 'YYYY-MM-DD').format('DD/MM/YYYY')} instead of ${moment(submittedStartDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}`)
                }
                if (submittedEndDate && savedEndDate && savedEndDate !== submittedEndDate) {
                    mismatches.push(`end date is still ${moment(savedEndDate, 'YYYY-MM-DD').format('DD/MM/YYYY')} instead of ${moment(submittedEndDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}`)
                }
                if (mismatches.length) {
                    Notification.error('Date not saved', `The schedule was updated, but the ${mismatches.join(' and ')}. Please contact support.`)
                }
            })
        }

        try {
            try { onCancel() } catch (er) { }
            try { onSave({ date: verifyDate }) } catch (er) { }
        } catch (e) {
            console.error(e)
        }
        if (togglePageLoader) togglePageLoader(false)
        setSubject(null)
        setSubName('')
        setTeacher(null)
        setSartDate('')
        setEndDate('')
        setStartTime('')
        setEndTime('')
        setMode('')
        setWeekDays([])
        setClass([])
        setClassNameArr([])

        // Scroll to top after success
        window.scrollTo(0, 0);
        const drawerBody = document.querySelector('.ant-drawer-body');
        if (drawerBody) {
            drawerBody.scrollTo(0, 0);
        }
    }

    const isResetDisabled = (() => {
        if (!initialFormState) return true
        try {
            const sameSub = initialFormState.subId === currentSubId
            const sameTeacher = initialFormState.teacherId === currentTeacherId
            const sameStart = initialFormState.startTime === currentStartTime
            const sameEnd = initialFormState.endTime === currentEndTime
            const sameStartDate = initialFormState.startDate === currentStartDate
            const sameEndDate = initialFormState.endDate === currentEndDate
            const sameMode = initialFormState.mode === currentMode
            const sameClass = JSON.stringify(initialFormState.classId || []) === JSON.stringify(currentClassIds || [])
            const sameWeek = JSON.stringify(initialFormState.weekdays || []) === JSON.stringify(currentWeekdays || [])
            return (sameSub && sameTeacher && sameStart && sameEnd && sameStartDate && sameEndDate && sameMode && sameClass && sameWeek)
        } catch (e) { return true }
    })()

    const handleBatchFieldClick = () => {
        if (currentSubId) {
            setShowBatchInput(true)
            setBatchDropdownOpen(true)
            fetchClassList('', currentSubId)
        }
    }

    const selectedBatches = Array.isArray(currentClassIds) ? currentClassIds : [];
    const totalBatches = (cachedClassList || classList || classNameArr);
    const availableBatches = totalBatches.filter(c => !selectedBatches.includes(c.id));
    const showAddBatch = totalBatches.length > 1 && selectedBatches.length > 0 && availableBatches.length > 0;

    // Hold the spinner until the prefill effect has run for THIS class, so the form
    // never renders with the last class's subject/batch/teacher/date/time still in
    // redux. One frame in practice, and the same Spin the no-schedule guard above uses.
    if (prefilledKey !== editingScheduleKey) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', minHeight: 300 }}>
                <Spin size="large" />
            </div>
        );
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', position: 'relative' }}>
            {pageLoader && ReactDOM.createPortal(
                <PageDataLoader visible={true} />,
                document.body
            )}
            <div
                className="schedule-edit-tab-body"
                style={{
                    padding: '24px var(--edit-body-padding)',
                    fontFamily: 'Roboto, sans-serif',
                    paddingBottom: 24,
                    position: 'relative',
                    flex: 1,
                    overflowY: 'auto'
                }}>
                {accessEdit && (
                    <div style={{
                        background: '#FFE5E5',
                        borderRadius: 8,
                        padding: '12px 16px',
                        color: '#D32F2F',
                        marginBottom: 24,
                        fontSize: 18,
                        lineHeight: '20px'
                    }}>
                        On-going class is not editable. Please try again once the class is over.
                    </div>
                )}

                {/* Subject Field */}
                <div id="edit-subject-field" style={{ marginBottom: fieldGap, paddingTop: 30, position: 'relative' }}>
                    <div
                        style={{
                            position: 'absolute',
                            left: 0,
                            top: (subFocused || subName || currentSubId) ? '0px' : '30px',
                            fontSize: '16px',
                            color: (subFocused || subName || currentSubId) ? '#636363' : '#636363',
                            fontWeight: 500,
                            transition: 'all 0.2s ease',
                            pointerEvents: 'none',
                        }}
                    >
                        Subject <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
                    </div>

                    <div style={{ position: 'relative', width: '100%' }}>
                        <Tooltip title={subName} placement="topLeft" mouseEnterDelay={0.5}>
                            <AutoComplete
                                className="custom-schedule-select"
                            popupClassName="schedule-edit-dropdown-v2"
                            style={{ width: '100%' }}
                            virtual={false}
                            dropdownMatchSelectWidth={true}
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            options={optionSub}
                            open={subjectDropdownOpen}
                            notFoundContent={subjectLoader ? 'Loading...' : <div style={{ padding: '8px 12px', color: '#6B6B6B' }}>No subject found</div>}
                            onSearch={handleSearchSub}
                            onFocus={() => {
                                setSubFocused(true);
                                setIsSearchingSub(false);
                                fetchSubList('');
                                setSubjectDropdownOpen(true);
                                setShowBatchInput(false);
                                setBatchFocused(false);
                            }}
                            onBlur={() => {
                                setSubFocused(false);
                            }}
                            onDropdownVisibleChange={(open) => {
                                if (open) setIsSearchingSub(false);
                                // when suppressed after clear, ignore close events so dropdown stays open
                                if (suppressSubOptionsUpdate && !open) return;
                                if (suppressSubOptionsUpdate && open) {
                                    setSubjectDropdownOpen(true);
                                    return;
                                }
                                setSubjectDropdownOpen(open);

                                if (open) {
                                    const list = cachedSubList || subList || [];
                                    setOptionsSub(
                                        list.map((item, index) => ({
                                            key: index,
                                            value: item.name,
                                            label: item.name,
                                            id: item.id,
                                            className: item.id === currentSubId ? 'custom-selected-option' : ''
                                        }))
                                    );
                                    fetchSubList('');
                                }
                            }}
                            onSelect={(value, option) => {
                                onSelectSub(value, option);
                                setSubjectDropdownOpen(false);
                            }}
                            onChange={(value) => {
                                if (!value) {
                                    setSubName('');
                                    setSubject(null);
                                    setClass([]);
                                    setClassNameArr([]);
                                    setClassName('');
                                    setShowBatchInput(false);
                                    setCachedClassList(null); // Clear cache to hide button

                                    if (isManualClearRef.current) {
                                        isManualClearRef.current = false;
                                        setSubFocused(true);
                                        setSubjectDropdownOpen(true);
                                        // Don't blur
                                    } else {
                                        setSubFocused(false);
                                        subRef.current?.blur();
                                        setSubjectDropdownOpen(false);
                                    }

                                    // Prevent useEffect from immediately overwriting our options while we refresh
                                    setSuppressSubOptionsUpdate(true);

                                    // Refresh subjects in background
                                    const list = (cachedSubList && cachedSubList.length > 0) ? cachedSubList : (subList || []);
                                    if (list && list.length > 0) {
                                        setOptionsSub(list.map((item, index) => ({ key: index, value: item.name, label: item.name, id: item.id })));
                                        // allow the background fetch to update options after suppression window
                                        setTimeout(() => setSuppressSubOptionsUpdate(false), 1000);
                                        // Refresh subjects in background to update options without causing flicker
                                        setTimeout(() => fetchSubList(''), 300);
                                    } else {
                                        // allow the background fetch to update options after suppression window
                                        setTimeout(() => setSuppressSubOptionsUpdate(false), 1000);
                                        // Fetch fresh list
                                        fetchSubList('', () => setSubjectLoader(false));
                                    }
                                } else {
                                    isManualClearRef.current = false;
                                }
                            }}
                            ref={subRef}
                            value={subName}
                            allowClear
                            placeholder=""
                            filterOption={false}
                            dropdownStyle={{ marginTop: 2 }}
                        >
                            <Input
                                bordered={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Backspace' || e.key === 'Delete') {
                                        isManualClearRef.current = true;
                                    }
                                    const noSubFound = !optionSub || optionSub.length === 0 || (optionSub.length === 1 && optionSub[0].key === 'no-data');
                                    if (e.key === 'Enter') {
                                        if (!subName || noSubFound) {
                                            e.preventDefault();
                                            setIsSearchingSub(false);
                                            setSubjectDropdownOpen(true);
                                            fetchSubList('');
                                        } else if (optionSub && optionSub.length > 0) {
                                            // Select the first valid option if available
                                            const firstValid = optionSub.find(o => o.key !== 'no-data');
                                            if (firstValid) {
                                                onSelectSub(firstValid.value, firstValid);
                                                setSubjectDropdownOpen(false);
                                            }
                                        }
                                    }
                                }}
                                style={{
                                    padding: 0,
                                    fontSize: 18,
                                    color: '#191919',
                                    fontWeight: 500,
                                    cursor: 'pointer',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap'
                                }}
                            />
                        </AutoComplete>
                        </Tooltip>
                    </div>

                    <div
                        style={{
                            width: '100%',
                            height: '0px',
                            borderTop: '1px solid #E6E6E6',
                            opacity: 1,
                        }}
                    />
                </div>

                {/* Batch Field */}
                <div style={{ marginBottom: fieldGap, paddingTop: 30, position: 'relative' }}>
                    <div style={{
                        position: 'absolute',
                        left: 0,
                        top: (currentSubId && (batchFocused || classNameArr.length > 0 || showBatchInput)) ? '0px' : '30px',
                        fontSize: '16px',
                        color: (currentSubId && (batchFocused || classNameArr.length > 0 || showBatchInput)) ? '#636363' : '#636363',
                        fontWeight: 500,
                        transition: 'all 0.2s ease',
                        pointerEvents: 'none',
                    }}>
                        Batch <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                        {(classNameArr || []).map((c) => (
                            <div key={c.id}>
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: '4px 0 0px 0'
                                    }}
                                >
                                    <Tooltip title={c.name}>
                                        <span style={{
                                            fontSize: 18,
                                            color: '#191919',
                                            fontWeight: 500,
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            paddingBottom: 2,
                                            lineHeight: 'normal',
                                            maxWidth: 'calc(100% - 30px)'
                                        }}>
                                            {c.name}
                                        </span>
                                    </Tooltip>
                                    <img
                                        src={deleteIcon}
                                        onClick={() => onClose(c.id)}
                                        alt="delete"
                                        style={{
                                            width: 24,
                                            height: 24,
                                            opacity: 1,
                                            cursor: 'pointer',
                                            filter: 'invert(40%) sepia(90%) saturate(1500%) hue-rotate(330deg) brightness(95%) contrast(105%)',
                                            marginRight: -4
                                        }}
                                    />
                                </div>
                                <div style={{ width: '100%', height: '0px', borderTop: '1px solid #E6E6E6', opacity: 1 }} />
                            </div>
                        ))}
                    </div>

                    <div id="edit-batch-input-area" style={{ position: 'relative', marginTop: classNameArr.length > 0 ? 18 : 0 }}>
                        {classNameArr.length === 0 && !showBatchInput ? (
                            <div
                                onClick={handleBatchFieldClick}
                                style={{
                                    cursor: currentSubId ? 'pointer' : 'not-allowed',
                                }}
                            >
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '4px 0 0px 0'
                                }}>
                                    <div style={{
                                        fontSize: 18,
                                        color: '#A0A0A0',
                                        fontWeight: 500,
                                        height: 22
                                    }}>

                                    </div>
                                    <img
                                        src={downArrowIcon}
                                        alt="down arrow"
                                        style={{
                                            width: 24,
                                            height: 24,
                                            marginRight: -4,
                                            cursor: currentSubId ? 'pointer' : 'not-allowed'
                                        }}
                                    />
                                </div>
                                <div style={{ width: '100%', height: 0, borderTop: '1px solid #E6E6E6', opacity: 1 }} />
                            </div>
                        ) : showBatchInput ? (
                            <div style={{ position: 'relative', width: '100%' }}>
                                <AutoComplete
                                    className="custom-schedule-select"
                                    popupClassName="schedule-edit-dropdown-v2"
                                    style={{ width: '100%' }}
                                    virtual={false}
                                    dropdownMatchSelectWidth={true}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                    options={optionClass}
                                    open={batchDropdownOpen}
                                    notFoundContent={stdLoader ? 'Loading...' : <div style={{ padding: '8px 12px', color: '#6B6B6B' }}>No batch found</div>}
                                    onSearch={handleSearchClass}
                                    onFocus={() => {
                                        setBatchFocused(true)
                                        fetchClassList('', currentSubId)
                                        setBatchDropdownOpen(true)
                                    }}
                                    onBlur={() => {
                                        setBatchFocused(false)
                                    }}
                                    onDropdownVisibleChange={(open) => {
                                        setBatchDropdownOpen(open);
                                        if (open) {
                                            const selectedIds = Array.isArray(currentClassIds) ? currentClassIds : []
                                            const list = cachedClassList || classList || [];
                                            const available = list.filter(c => !selectedIds.includes(c.id));
                                            setOptionsClass(available.map((item, index) => ({
                                                key: index,
                                                value: `${item.std} : ${item.section}`,
                                                label: `${item.std} : ${item.section}`,
                                                id: item.id
                                            })));
                                            fetchClassList('', currentSubId);
                                        }
                                    }}
                                    onSelect={(value, option) => {
                                        onSelectClass(value, option)
                                        setBatchDropdownOpen(false)
                                    }}
                                    onChange={(value) => {
                                        setClassName(value)
                                    }}
                                    value={className}
                                    placeholder=""
                                    filterOption={false}
                                    dropdownStyle={{ marginTop: 2 }}
                                >
                                    <Input
                                        bordered={false}
                                        style={{
                                            padding: 0,
                                            fontSize: 18,
                                            color: '#191919',
                                            fontWeight: 500,
                                            cursor: currentSubId ? 'pointer' : 'not-allowed',
                                            height: 22
                                        }}
                                        suffix={
                                            <img
                                                src={batchDropdownOpen ? upArrowIcon : downArrowIcon}
                                                alt={batchDropdownOpen ? "up arrow" : "down arrow"}
                                                style={{
                                                    width: 24,
                                                    height: 24,
                                                    cursor: 'pointer',
                                                    marginRight: -4
                                                }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (batchDropdownOpen) {
                                                        setBatchDropdownOpen(false)
                                                    } else {
                                                        setBatchDropdownOpen(true)
                                                        fetchClassList('', currentSubId)
                                                    }
                                                }}
                                            />
                                        }
                                    />
                                </AutoComplete>
                                <div style={{ width: '100%', height: 0, borderTop: '1px solid #E6E6E6', opacity: 1 }} />
                            </div>
                        ) : null}
                    </div>

                    {currentSubId && showBatchInput && classNameArr.length > 0 ? (
                        <div
                            onClick={() => {
                                setShowBatchInput(false);
                                setBatchDropdownOpen(false);
                                setBatchFocused(false);
                                setClassName('');
                            }}
                            style={{
                                color: '#636363',
                                fontWeight: 700,
                                fontSize: 18,
                                cursor: 'pointer',
                                letterSpacing: '0.5px',
                                textAlign: 'right',
                                userSelect: 'none',
                                marginTop: 16
                            }}
                            role="button"
                        >
                            DISCARD
                        </div>
                    ) : currentSubId && !showBatchInput ? (
                        <>
                            {showAddBatch && (
                                <div
                                    onClick={() => {
                                        if (currentSubId) {
                                            setShowBatchInput(true);
                                            setBatchDropdownOpen(false);
                                            fetchClassList('', currentSubId)
                                        }
                                    }}
                                    style={{
                                        color: currentSubId ? '#1089FF' : '#A0A0A0',
                                        fontWeight: 700,
                                        fontSize: 18,
                                        cursor: currentSubId ? 'pointer' : 'not-allowed',
                                        letterSpacing: '0.5px',
                                        textAlign: 'right',
                                        userSelect: 'none',
                                        marginTop: 16
                                    }}
                                    role="button"
                                    aria-disabled={!currentSubId}
                                >
                                    ADD BATCH
                                </div>
                            )}
                        </>
                    ) : (
                        <div style={{ height: 12 }} />
                    )}
                </div>

                {/* Instructor Field */}
                <div id="edit-instructor-field" style={{ marginBottom: fieldGap, paddingTop: 30, position: 'relative' }}>
                    <div style={{
                        position: 'absolute',
                        left: 0,
                        top: (teacherFocused || teacherName || currentTeacherId) ? '0px' : '30px',
                        fontSize: '16px',
                        color: (teacherFocused || teacherName || currentTeacherId) ? '#636363' : '#636363',
                        fontWeight: 500,
                        transition: 'all 0.2s ease',
                        pointerEvents: 'none',
                    }}>
                        Instructor <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
                    </div>
                    <div style={{ position: 'relative', width: '100%' }}>
                        <AutoComplete
                            className="custom-schedule-select"
                            popupClassName="schedule-edit-dropdown-v2"
                            style={{ width: '100%' }}
                            virtual={false}
                            dropdownMatchSelectWidth={true}
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            options={optionTeacher}
                            onSearch={handleSearchTeacher}
                            onFocus={() => {
                                setTeacherFocused(true);
                                setIsSearchingTeacher(false);
                                fetchTeacherList('');
                                setTeacherDropdownOpen(true);
                            }}
                            onBlur={() => {
                                setTeacherFocused(false);
                            }}
                            onDropdownVisibleChange={(open) => {
                                if (open) setIsSearchingTeacher(false);
                                setTeacherDropdownOpen(open);
                                if (open) {
                                    const list = cachedTeacherList || teacherList || [];
                                    setOptionsTeacher(list ? list.map((item, index) => ({
                                        key: index,
                                        value: item.name,
                                        label: item.name,
                                        id: item.id,
                                        className: item.id === currentTeacherId ? 'custom-selected-option' : ''
                                    })) : []);
                                    fetchTeacherList('')
                                }
                            }}
                            onSelect={(value, option) => {
                                onSelectTeacher(value, option);
                                setTeacherDropdownOpen(false);
                            }}
                            onChange={(value) => {
                                if (!value) {
                                    setTeacherName('')
                                    setTeacher(null)
                                    if (isManualClearRef.current) {
                                        isManualClearRef.current = false;
                                        setTeacherFocused(true);
                                    } else {
                                        setTeacherFocused(false)
                                        instructorRef.current?.blur()
                                    }
                                } else {
                                    isManualClearRef.current = false;
                                }
                            }}
                            ref={instructorRef}
                            value={teacherName}
                            open={teacherDropdownOpen}
                            notFoundContent={teacherLoader ? 'Loading...' : <div style={{ padding: '8px 12px', color: '#6B6B6B' }}>No instructor found</div>}
                            allowClear={true}
                            placeholder=""
                            filterOption={false}
                            dropdownStyle={{ marginTop: 2 }}
                        >
                            <Input
                                bordered={false}
                                onKeyDown={(e) => {
                                    if (e.key === 'Backspace' || e.key === 'Delete') {
                                        isManualClearRef.current = true;
                                    }
                                    const noTeacherFound = !optionTeacher || optionTeacher.length === 0 || (optionTeacher.length === 1 && optionTeacher[0].key === 'no-data');
                                    if (e.key === 'Enter') {
                                        if (!teacherName || noTeacherFound) {
                                            e.preventDefault();
                                            setIsSearchingTeacher(false);
                                            setTeacherDropdownOpen(true);
                                            fetchTeacherList('');
                                        } else if (optionTeacher && optionTeacher.length > 0) {
                                            // Select the first valid option if available
                                            const firstValid = optionTeacher.find(o => o.key !== 'no-data');
                                            if (firstValid) {
                                                onSelectTeacher(firstValid.value, firstValid);
                                                setTeacherDropdownOpen(false);
                                            }
                                        }
                                    }
                                }}
                                style={{
                                    padding: 0,
                                    fontSize: 18,
                                    color: '#191919',
                                    fontWeight: 500,
                                    cursor: 'pointer'
                                }}
                            />
                        </AutoComplete>
                    </div>
                    <div style={{ width: '100%', height: '0px', borderTop: '1px solid #E6E6E6', opacity: 1 }} />
                </div>

                <style>
                    {`
  :root {
    --edit-body-padding: 40px;
  }
  @media (max-height: 950px) { :root { --edit-body-padding: 24px; } }
  @media (max-height: 850px) { :root { --edit-body-padding: 20px; } }
  @media (max-height: 750px) { :root { --edit-body-padding: 18px; } }
  @media (max-height: 650px) { :root { --edit-body-padding: 16px; } }

  body .schedule-edit-dropdown-v2,
  .schedule-edit-dropdown-v2 {
    position: absolute !important;
    top: 100% !important;
    left: 0 !important;
    width: 100% !important;
    transform: none !important;
    min-width: unset !important;
    max-width: 100% !important;
    overflow: hidden !important;
    border-radius: 12px !important;
    background: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin-top: 22px !important;
    z-index: 1200 !important;
  }

  body .schedule-edit-dropdown-v2 > *,
  .schedule-edit-dropdown-v2 > * {
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box !important;
    margin-top: 8px !important;
    border-radius: 12px !important;
    box-shadow: 0 0 16px rgba(0, 0, 0, 0.16) !important;
    border: 1px solid #E6E6E6 !important;
    background: #ffffff !important;
    padding: 8px 4px !important;
  }

  body .schedule-edit-dropdown-v2.ant-select-dropdown-empty,
  .schedule-edit-dropdown-v2.ant-select-dropdown-empty,
  body .schedule-edit-dropdown-v2.ant-select-dropdown-hidden,
  .schedule-edit-dropdown-v2.ant-select-dropdown-hidden {
    display: none !important;
    opacity: 0 !important;
    pointer-events: none !important;
  }

  body .schedule-edit-dropdown-v2.ant-select-dropdown-empty > *,
  .schedule-edit-dropdown-v2.ant-select-dropdown-empty > *,
  body .schedule-edit-dropdown-v2.ant-select-dropdown-hidden > *,
  .schedule-edit-dropdown-v2.ant-select-dropdown-hidden > * {
    display: none !important;
    box-shadow: none !important;
    border: none !important;
    padding: 0 !important;
  }

  body .schedule-edit-dropdown-v2 .rc-virtual-list,
  body .schedule-edit-dropdown-v2 .rc-virtual-list-holder,
  body .schedule-edit-dropdown-v2 .rc-virtual-list-holder-inner {
    width: 100% !important;
    max-width: 100% !important;
  }

  .datepicker-timepicker-relative-container {
    position: relative;
    width: 100%;
  }

  body .datepicker-timepicker-relative-container .ant-picker-dropdown,
  .datepicker-timepicker-relative-container .ant-picker-dropdown {
    position: absolute !important;
    top: 100% !important;
    left: 0 !important;
    transform: none !important;
    margin-top: 30px !important;
    z-index: 1200 !important;
  }


  body .schedule-edit-dropdown-v2 .ant-select-item-option-content,
  body .schedule-edit-dropdown-v2 .ant-select-item {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  body .schedule-edit-dropdown-v2 .ant-select-item-option-selected,
  body .schedule-edit-dropdown-v2 .custom-selected-option {
    background-color: #C6C2FF !important;
    color: #191919 !important;
    font-weight: 400;
    font-size: 14px !important;
  }

  body .schedule-edit-dropdown-v2 .ant-select-item-option-active {
    background-color: #C6C2FF !important;
  }

  body .schedule-edit-dropdown-v2 .ant-select-item {
    border-radius: 8px;
    margin: 4px;
    padding: 6px 16px;
    font-size: 14px !important;
    color: #636363;
  }

  body .schedule-edit-dropdown-v2 .ant-select-item-option-content {
    font-size: 14px !important;
  }

  .ant-input-affix-wrapper,
  .ant-input-affix-wrapper-focused,
  .ant-input-affix-wrapper:hover {
    border: none !important;
    box-shadow: none !important;
  }

  .ant-input-affix-wrapper::before,
  .ant-input-affix-wrapper::after {
    display: none !important;
  }

  .ant-picker,
  .ant-picker-focused,
  .ant-picker:hover {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
  }

  .ant-picker::before,
  .ant-picker::after {
    display: none !important;
  }
`}
                </style>

                {/* Mode of Class */}
                <div style={{ marginBottom: fieldGap }}>
                    <div
                        style={{
                            fontSize: 16,
                            color: '#636363',
                            marginBottom: 8,
                            fontWeight: 500,
                        }}
                    >
                        Mode of class <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
                    </div>

                    <div style={{ display: 'flex', gap: 10 }}>
                        {['Broadcast', 'Offline', 'Others'].map((m) => (
                            <div
                                key={m}
                                onClick={() => setMode(m)}
                                style={{
                                    padding: '8px 32px',
                                    borderRadius: 12,
                                    border: currentMode === m ? 'none' : '1px solid #E6E6E6',
                                    background: currentMode === m ? '#C6C2FF' : '#FFFFFF',
                                    color: '#191919',
                                    fontSize: 18,
                                    fontWeight: 500,
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.2s ease',
                                }}
                            >
                                {m === 'Broadcast' ? 'Online' : m}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Date Fields */}
                <div style={{ display: 'flex', gap: 24, marginBottom: fieldGap }}>
                    <div style={{ flex: 1, position: 'relative', paddingTop: 30 }}>
                        <div style={{
                            position: 'absolute',
                            left: 0,
                            top: (startDateFocused || currentStartDate) ? '0px' : '30px',
                            fontSize: '16px',
                            color: (startDateFocused || currentStartDate) ? '#636363' : '#636363',
                            fontWeight: 500,
                            transition: 'all 0.2s ease',
                            pointerEvents: 'none',
                        }}>
                            Start date <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
                        </div>
                        <div ref={startDateWrapRef} onMouseEnter={() => setHoverStartDate(true)} onMouseLeave={() => setHoverStartDate(false)} className="datepicker-timepicker-relative-container">
                            <DatePicker
                                value={currentStartDate ? moment(currentStartDate, 'YYYY-MM-DD') : null}
                                format={formatDate}
                                onChange={onChangeStartDate}
                                onOpenChange={(open) => { setStartDateFocused(open); if (open) scrollFieldIntoView(startDateWrapRef); }}
                                style={pickerStyle}
                                inputReadOnly
                                bordered={false}
                                disabledDate={disabledStartDate}
                                disabled={editType === 'occurrence'}
                                suffixIcon={(currentStartDate && hoverStartDate && editType !== 'occurrence') ? null : <img src={calenderIcon} alt="calendar" style={{ width: 24, height: 24 }} />}
                                allowClear={editType !== 'occurrence'}
                                placeholder=""
                                popupStyle={{ marginTop: 30 }}
                                ref={startDateRef}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            />
                        </div>
                        <div style={{ width: '100%', height: '0px', borderTop: '1px solid #E6E6E6', opacity: 1 }} />
                    </div>
                    <div style={{ flex: 1, position: 'relative', paddingTop: 30 }}>
                        <div style={{
                            position: 'absolute',
                            left: 0,
                            top: (endDateFocused || currentEndDate) ? '0px' : '30px',
                            fontSize: '16px',
                            color: (endDateFocused || currentEndDate) ? '#636363' : '#636363',
                            fontWeight: 500,
                            transition: 'all 0.2s ease',
                            pointerEvents: 'none',
                        }}>
                            End date <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
                        </div>
                        <div ref={endDateWrapRef} onMouseEnter={() => setHoverEndDate(true)} onMouseLeave={() => setHoverEndDate(false)} className="datepicker-timepicker-relative-container">
                            <DatePicker
                                value={currentEndDate ? moment(currentEndDate, 'YYYY-MM-DD') : null}
                                format={formatDate}
                                onChange={onChangeLastDate}
                                onOpenChange={(open) => { setEndDateFocused(open); if (open) scrollFieldIntoView(endDateWrapRef); }}
                                style={pickerStyle}
                                inputReadOnly
                                bordered={false}
                                disabled={!currentStartDate || editType === 'occurrence'}
                                disabledDate={disabledDate}
                                suffixIcon={(currentEndDate && hoverEndDate && editType !== 'occurrence') ? null : <img src={calenderIcon} alt="calendar" style={{ width: 24, height: 24 }} />}
                                allowClear={editType !== 'occurrence'}
                                placeholder=""
                                popupStyle={{ marginTop: 30 }}
                                ref={endDateRef}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            />
                        </div>
                        <div style={{ width: '100%', height: '0px', borderTop: '1px solid #E6E6E6', opacity: 1 }} />
                    </div>
                </div>

                {/* Time Fields */}
                <div style={{ display: 'flex', gap: 24, marginBottom: fieldGap }}>
                    <div style={{ flex: 1, position: 'relative', paddingTop: 30 }}>
                        <div style={{
                            position: 'absolute',
                            left: 0,
                            top: (startTimeFocused || currentStartTime) ? '0px' : '30px',
                            fontSize: '16px',
                            color: (startTimeFocused || currentStartTime) ? '#636363' : '#636363',
                            fontWeight: 500,
                            transition: 'all 0.2s ease',
                            pointerEvents: 'none',
                        }}>
                            Start time <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
                        </div>
                        <div ref={startTimeWrapRef} onMouseEnter={() => setHoverStartTime(true)} onMouseLeave={() => setHoverStartTime(false)} className="datepicker-timepicker-relative-container">
                            <TimePicker
                                value={currentStartTime ? moment(currentStartTime, 'HH:mm') : null}
                                format={format}
                                onChange={onChangeStartTime}
                                onOpenChange={(open) => { setStartTimeFocused(open); if (open) scrollFieldIntoView(startTimeWrapRef); }}
                                style={pickerStyle}
                                inputReadOnly
                                bordered={false}
                                disabled={!(currentStartDate && currentEndDate)}
                                disabledHours={() => disabledStartTimeHours()}
                                disabledMinutes={disabledStartTimeMinutes}
                                suffixIcon={(currentStartTime && hoverStartTime) ? null : <img src={clockIcon} alt="clock" style={{ width: 24, height: 24 }} />}
                                allowClear={true}
                                placeholder=""
                                showNow={false}
                                popupStyle={{ marginTop: 30 }}
                                ref={startTimeRef}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            />
                        </div>
                        <div style={{ width: '100%', height: '0px', borderTop: '1px solid #E6E6E6', opacity: 1 }} />
                    </div>
                    <div style={{ flex: 1, position: 'relative', paddingTop: 30 }}>
                        <div style={{
                            position: 'absolute',
                            left: 0,
                            top: (endTimeFocused || currentEndTime) ? '0px' : '30px',
                            fontSize: '16px',
                            color: (endTimeFocused || currentEndTime) ? '#636363' : '#636363',
                            fontWeight: 500,
                            transition: 'all 0.2s ease',
                            pointerEvents: 'none',
                        }}>
                            End time <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
                        </div>
                        <div ref={endTimeWrapRef} onMouseEnter={() => setHoverEndTime(true)} onMouseLeave={() => setHoverEndTime(false)} className="datepicker-timepicker-relative-container">
                            <TimePicker
                                value={currentEndTime ? moment(currentEndTime, 'HH:mm') : null}
                                format={format}
                                onChange={onChangeEndTime}
                                onOpenChange={(open) => { setEndTimeFocused(open); if (open) scrollFieldIntoView(endTimeWrapRef); }}
                                style={pickerStyle}
                                inputReadOnly
                                bordered={false}
                                disabled={!currentStartTime}
                                disabledHours={() => disabledEndTimeHours()}
                                disabledMinutes={disabledEndTimeMinutes}
                                suffixIcon={(currentEndTime && hoverEndTime) ? null : <img src={clockIcon} alt="clock" style={{ width: 24, height: 24 }} />}
                                allowClear={true}
                                placeholder=""
                                showNow={false}
                                popupStyle={{ marginTop: 30 }}
                                ref={endTimeRef}
                                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            />
                        </div>
                        <div style={{ width: '100%', height: '0px', borderTop: '1px solid #E6E6E6', opacity: 1 }} />
                    </div>
                </div>

                {/* Repeat On */}
                <div style={{ marginBottom: fieldGap }}>
                    <div style={{
                        fontSize: 16,
                        color: '#636363',
                        marginBottom: 10,
                        fontWeight: 500
                    }}>
                        Repeat on <span style={{ color: '#D32F2F', marginLeft: 6 }}>*</span>
                    </div>
                    <div style={{ display: 'flex', gap: 12, justifyContent: 'space-between' }}>
                        {['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].map((d, i) => {
                            const dayMap = ['Su', 'M', 'T', 'W', 'Th', 'F', 'S']
                            return (
                                <div
                                    key={d}
                                    onClick={() => {
                                        if (editType !== 'occurrence') {
                                            handleDaysButtonColor(dayMap[i], colorDays[i])
                                        }
                                    }}
                                    style={{
                                        width: 51,
                                        height: 51,
                                        borderRadius: '50%',
                                        background: colorDays[i] ? '#C6C2FF' : '#FFFFFF',
                                        border: colorDays[i] ? 'none' : '1px solid #E6E6E6',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: 18,
                                        fontWeight: 500,
                                        color: '#191919',
                                        cursor: editType === 'occurrence' ? 'not-allowed' : 'pointer',
                                        opacity: editType === 'occurrence' ? 0.6 : 1,
                                        transition: 'all 0.2s ease'
                                    }}
                                >
                                    {d}
                                </div>
                            )
                        })}
                    </div>
                </div>

                <div style={{ height: 12 }} />
            </div>

            {/* Fixed footer with action buttons */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 10,
                padding: '16px 24px',
                background: '#FFFFFF',
                boxShadow: '0 -2px 8px rgba(0,0,0,0.06)',
                zIndex: 1100,
                borderTop: '1px solid #E6E6E6',
                width: '100%',
                boxSizing: 'border-box'
            }}>
                <button
                    onClick={onCancel}
                    style={{
                        width: 140,
                        height: 45,
                        borderRadius: 12,
                        border: '1px solid #636363',
                        background: '#FFFFFF',
                        color: '#636363',
                        fontSize: 18,
                        fontWeight: 700,
                        cursor: 'pointer',
                        letterSpacing: '0.5px',
                        transition: 'all 0.2s ease',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    BACK
                </button>

                <div style={{ display: 'flex', gap: 10 }}>
                    <button
                    onClick={() => {
                        if (initialFormState) {
                            setSubName(initialFormState.subName)
                            setSubject(initialFormState.subId)
                            setClass(initialFormState.classId)
                            setClassNameArr(initialFormState.classNameArr)
                            setClassName('')
                            setTeacherName(initialFormState.teacherName)
                            setTeacher(initialFormState.teacherId)
                            setStartTime(initialFormState.startTime)
                            setEndTime(initialFormState.endTime)
                            setSartDate(initialFormState.startDate)
                            setEndDate(initialFormState.endDate)
                            setMode(initialFormState.mode)
                            setWeekDays(initialFormState.weekdays)
                            setColorDays(initialFormState.colorDays)

                            // Scroll to top on reset
                            window.scrollTo(0, 0);
                            const drawerBody = document.querySelector('.ant-drawer-body');
                            if (drawerBody) {
                                drawerBody.scrollTo(0, 0);
                            }
                        }
                    }}
                    disabled={isResetDisabled}
                    style={{
                        width: 140,
                        height: 45,
                        borderRadius: 12,
                        border: '1px solid #636363',
                        background: '#FFFFFF',
                        color: '#636363',
                        fontSize: 18,
                        fontWeight: 700,
                        cursor: isResetDisabled ? 'not-allowed' : 'pointer',
                        letterSpacing: '0.5px',
                        transition: 'all 0.2s ease',
                        opacity: isResetDisabled ? 0.7 : 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    RESET
                </button>

                <button
                    onClick={() => { if (isFormValidEdit) setShowSavingModal(true) }}
                    disabled={pageLoader || !isFormValidEdit || isResetDisabled}
                    style={{
                        width: 140,
                        height: 45,
                        borderRadius: 12,
                        border: 'none',
                        background: '#594099',
                        color: '#FFFFFF',
                        fontSize: 18,
                        fontWeight: 700,
                        cursor: (pageLoader || !isFormValidEdit || isResetDisabled) ? 'not-allowed' : 'pointer',
                        letterSpacing: '0.5px',
                        opacity: (pageLoader || !isFormValidEdit || isResetDisabled) ? 0.7 : 1,
                        transition: 'all 0.2s ease',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    SAVE
                </button>
                </div>
            </div>

            {/* SavingModal (components/SavingModal.js) is shared across 8 schedule-module
                files (ResourcesPanel, ResourceAddForm, QuizzesPanel, scheduleAddQuiz,
                ScheduleDetailsDrawer, ScheduleDetailsTab, etc.) for unrelated confirmation
                dialogs — restyling it here would change all of them, so it is left as-is
                and is out of scope for this pass. */}
            <SavingModal
                visible={showSavingModal}
                onCancel={() => setShowSavingModal(false)}
                onConfirm={() => {
                    setShowSavingModal(false);
                    createSchedule();
                }}
            />
        </div>
    )
}

const mapStateToProps = (state) => {
    const { subList, subId, classList, teacherList, weekdays, classId, teacherId, startTime, endTime, startDate, endDate, mode, tabType, stdTimetable, currentDate, subsAlertData } = state.schedule
    return { subList, subId, classList, teacherList, weekdays, classId, teacherId, startTime, endTime, startDate, endDate, mode, tabType, stdTimetable, currentDate, subsAlertData }
}

const mapDispatchToProps = (dispatch) => ({
    fetchSubList: (s, cb) => dispatch(fetchSubList(s, cb)),
    fetchClassList: (s, id, cb) => dispatch(fetchClassList(s, id, cb)),
    fetchTeacherList: (s, cb) => dispatch(fetchTeacherList(s, cb)),
    setSubject: (id) => dispatch(setSubject(id)),
    setClass: (ids) => dispatch(setClass(ids)),
    setTeacher: (id) => dispatch(setTeacher(id)),
    setStartTime: (t) => dispatch(setStartTime(t)),
    setEndTime: (t) => dispatch(setEndTime(t)),
    setSartDate: (d) => dispatch(setSartDate(d)),
    setEndDate: (d) => dispatch(setEndDate(d)),
    setMode: (m) => dispatch(setMode(m)),
    setWeekDays: (w) => dispatch(setWeekDays(w)),
    postCreateSchedule: (obj, cb, sc) => dispatch(postCreateSchedule(obj, cb, sc)),
    postEditOccurance: (obj, cb, sc) => dispatch(postEditOccurance(obj, cb, sc)),
    setScheduleIdDelete: (id) => dispatch(setScheduleIdDelete(id)),
    fetchSchedule: (cb, date) => dispatch(fetchSchedule(cb, date)),
    fetchTimetableData: (id, cb) => dispatch(fetchTimetableData(id, cb)),
    fetchScheduleFilter: (date, topic, std, sub, cb) => dispatch(fetchScheduleFilter(date, topic, std, sub, cb)),
    setDelOrCancel: (v) => dispatch(setDelOrCancel(v)),
    setSubscriptionModal: (v) => dispatch(setSubscriptionModal(v)),
    setCurrentDate: (date) => dispatch(setCurrentDate(date)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleEditTab)